// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
};


var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
}
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/* Fixes mobile bug with back button, this prevents showing opened drawers like menu and search when going back to home page!*/
window.addEventListener('pagehide', function () {
  document.querySelector('.SearchWrapper').setAttribute("aria-hidden", true);
  document.querySelector('#sidebarDrawer').setAttribute("aria-expanded", false);
  document.querySelector('#cart').setAttribute("aria-expanded", false);
  document.querySelector('.CartDrawer').style.display = 'none';
})

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, true);
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, false);
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, useCapture);
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    if (this.element.getAttribute('id') == "cart"){
     this.pageOverlayElement = document.querySelector(".pageOverlayCart");
    } else {
      this.pageOverlayElement = document.querySelector(".pageOverlay");
    }

    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {

    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
      event.target.getAttribute("aria-controls")
    );
    
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    var focus = this.element.querySelector("[data-scrollable]");

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }
  closeModal() {

    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );

    if (this.activeModal.getAttribute('id') == 'upsellPopup'){
      document.querySelector('.cartCheckout--Button').removeAttribute('data-action');
      document.querySelector('.cartCheckout--Button').removeAttribute('aria-controls');
    }

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight(){
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener('resize', this.syncHeight());
    this.delegateElement.on(
      "touchstart",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".ProductSliderCell--Zoom",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );
  }
  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    var images = [],
    index_currentSlide = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      var index_currentSlide = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index_currentSlide]
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position");
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }
    console.log(images);

    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index_currentSlide)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    if (new Responsive().matchesBreakpoint("pocket")) {
      return;
    }

    // Create an array of images from the siblings of the target element.
    const images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (
        item.classList.contains("ProductSliderCell--Zoom") &&
        item.querySelector("img")
      ) {
        images.push(item.querySelector("img"));
      }
    });

    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(
      target
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position")
    );

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      imagePosition
    );
  }
  

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = new Responsive().matchesBreakpoint("phone")
          ? 800
          : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: new RevolutionImage().getSizedImageUrl(
          image.getAttribute("data-original-src"),
          requestedWidth + "x" + requestedHeight
        ),
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;

    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
              ".mainSwiper .ProductSliderCell--Zoom img"
            ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen('close', this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionDropdown");
    this.mainDropdown = this.element.querySelector(
      ".RevolutionDropdown--Content"
    );
    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionDropdown--InnerContent"
    );
    this.mainButton = this.element.querySelector(".RevolutionDropdown--Button");
    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    this.initSelectbox();
   
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);

    this.delegateBody.on("dropdown:close", (event)=>{
      event.stopImmediatePropagation();
      this.toggleDropdownCustom(event);
    })

    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );


     this.domDelegate.on("keydown", onEscape((event) => {
       this.closeDropdown(event.target);
    }));

    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  toggleDropdownCustom(event) {
    event.preventDefault();
    const element = event.target;
    const index = element.querySelector('.RevolutionDropdown--Content').dataset.index;

    let el = document.querySelector(`[data-index="${index}"]`);
    if (el){
      el = el.closest('.RevolutionDropdown').querySelector('.RevolutionDropdown--Button');
    }

    var isOpen = el.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      this.closeDropdown(el);
    } else {
      this.openDropdown(el);
    }
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl
        .querySelector('[value="' + value + '"]')
        .setAttribute("checked", "true");
    }
    this.mainButton.querySelector(".RevolutionDropdown--Title").innerHTML =
      innerContent;
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit() {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector(".RevolutionDropdown--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    var selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
      titleElement = this.element.querySelector(".RevolutionDropdown--Title");
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }
    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    console.log(target)
    var isOpen = target.getAttribute("aria-expanded") === "true";
    console.log(isOpen);
    if (isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
    document
    .querySelectorAll("footer button.closeHeader[data-action='toggle-selectbox'], main-menu-dropdown button.closeHeader[data-action='toggle-selectbox']").forEach((item) => {
        item.addEventListener("click", (event) => {
          event.preventDefault();
          console.log("clicked")
          this.toggleDropdown(event, event.currentTarget); // not event.target!
        });
    })
    
  }

  openDropdown(target) {
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );
    var siblings = new DomHelper().getSiblings(
      target.parentElement,
      ".RevolutionDropdown"
    );
    siblings.forEach(function (item) {
      item
        .querySelector(".RevolutionDropdown--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionDropdown--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionDropdown--Content").style.display = "none";
    });

    if (this.popover == true) {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );
      var focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus,bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
      trapFocus(this.mainDropdown);
      if(document.querySelector('#sidebarDrawer').getAttribute('aria-expanded') == "true"){
        document.querySelector('.SidebarDrawer--Wrapper').style.overflow = "visible";
      }
    }

    target.setAttribute("aria-expanded", true);

    target.parentElement
      .querySelector(".RevolutionDropdown--Content")
      .setAttribute("aria-hidden", false);
    target.parentElement.querySelector(
      ".RevolutionDropdown--Content"
    ).style.display = "block";
    window.addEventListener("click", this.onClickOutsideListener);
  }

  closeDropdown(target) {
    var closestDropdown = target.closest(".RevolutionDropdown");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionDropdown--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionDropdown--Content")
      .setAttribute("aria-hidden", true);
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionDropdown--Content"
      ).style.display = "none";
    }, 300);
    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );

      const menuDrawer = document.querySelector('#sidebarDrawer');

      if(menuDrawer.getAttribute('aria-expanded') == "true"){
        document.querySelector('.SidebarDrawer--Wrapper').style.overflow = "auto";
      }else{
        bodyScrollLock.clearAllBodyScrollLocks();
        document.body.classList.remove("scrollLock");
      }

    }
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);


  }
  
}

class Form {
  constructor() {}

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
        i = 0,
        _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );

    // Fallback for product forms that don't render a `[data-action=add-to-cart]` button.
    // Without this, the browser performs a normal form POST to `/cart/add` and Shopify redirects to `/cart`.
    this.delegateElement.on(
      "submit",
      'form[action*="/cart/add"]',
      this.onFormSubmit.bind(this)
    );
   
  }

  onFormSubmit(event) {
    event.preventDefault();
    const formElement = event.target;
    const submitter =
      event.submitter ||
      formElement.querySelector("[data-action=add-to-cart]") ||
      formElement.querySelector('button[type="submit"], input[type="submit"]');

    this.addToCartFromForm(formElement, submitter);
  }

  addToCart(event) {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + "%";
    var formElement = event.target.closest("form");
    this.addToCartFromForm(formElement, addToCartButton);
  }

  addToCartFromForm(formElement, addToCartButton) {
    var _this = this;
    if (!formElement) return;
    if (addToCartButton && addToCartButton.setAttribute) {
      addToCartButton.setAttribute("disabled", "disabled");
    }
    const idInput = formElement.querySelector('[name="id"]');
    if (idInput) idInput.removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (addToCartButton && addToCartButton.removeAttribute) {
          addToCartButton.removeAttribute("disabled");
        }
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            if (addToCartButton && addToCartButton.removeAttribute) {
              addToCartButton.removeAttribute("disabled");
            }
            if (addToCartButton && addToCartButton.insertAdjacentElement) {
              addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
            } else {
              formElement.appendChild(errorMessageElement);
            }
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }

}

class Dropdown {
  constructor(element) {
    this.element = element;
    this.domDelegate = new Delegate(this.element);
    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on("keydown", onEscape((event)=>{
      const dropdown = event.target.closest(".Dropdown");
      if (dropdown) {
        this.closeDropdown(dropdown);
      }
    }))
  }
  openDropdown(elem) {
    const dropdownButton = elem.querySelector(".DropdownButton"),
      dropdownContent = elem.querySelector(".DropdownContent");

    dropdownButton.setAttribute("aria-expanded", true);
    new RevolutionAnimation(dropdownContent, "true").slideDown();
  }

  closeDropdown(elem) {
    const dropdownButton = elem.querySelector(".DropdownButton"),
      dropdownContent = elem.querySelector(".DropdownContent");
    new RevolutionAnimation(dropdownContent, true).slideUp();
    dropdownButton.setAttribute("aria-expanded", false);
    /*setTimeout(function () {
      dropdownContent.setAttribute("aria-hidden", "true");
    }, 250);*/
  }
  toggleDropdown(event, target) {
    event.preventDefault(event);
    const mainDropdown = target.closest(".Dropdown");
    var isOpen = target.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      this.closeDropdown(mainDropdown, target);
    } else {
      this.openDropdown(mainDropdown, target);
    }
  }
}

(function (funcName, baseObj) {
  "use strict";
  // The public function name defaults to window.docReady
  // but you can modify the last line of this function to pass in a different object or method name
  // if you want to put them in a different namespace and those will be used instead of
  // window.docReady(...)
  funcName = funcName || "docReady";
  baseObj = baseObj || window;
  var readyList = [];
  var readyFired = false;
  var readyEventHandlersInstalled = false;

  // call this when the document is ready
  // this function protects itself against being called more than once
  function ready() {
    if (!readyFired) {
      // this must be set to true before we start calling callbacks
      readyFired = true;
      for (var i = 0; i < readyList.length; i++) {
        // if a callback here happens to add new ready handlers,
        // the docReady() function will see that it already fired
        // and will schedule the callback to run right after
        // this event loop finishes so all handlers will still execute
        // in order and no new ones will be added to the readyList
        // while we are processing the list
        readyList[i].fn.call(window, readyList[i].ctx);
      }
      // allow any closures held by these functions to free
      readyList = [];
    }
  }

  function readyStateChange() {
    if (document.readyState === "complete") {
      ready();
    }
  }

  // This is the one public interface
  // docReady(fn, context);
  // the context argument is optional - if present, it will be passed
  // as an argument to the callback
  baseObj[funcName] = function (callback, context) {
    if (typeof callback !== "function") {
      throw new TypeError("callback for docReady(fn) must be a function");
    }
    // if ready has already fired, then just schedule the callback
    // to fire asynchronously, but right away
    if (readyFired) {
      setTimeout(function () {
        callback(context);
      }, 1);
      return;
    } else {
      // add the function and context to the list
      readyList.push({ fn: callback, ctx: context });
    }
    // if document already ready to go, schedule the ready function to run
    // IE only safe when readyState is "complete", others safe when readyState is "interactive"
    if (
      document.readyState === "complete" ||
      (!document.attachEvent && document.readyState === "interactive")
    ) {
      setTimeout(ready, 1);
    } else if (!readyEventHandlersInstalled) {
      // otherwise if we don't have event handlers installed, install them
      if (document.addEventListener) {
        // first choice is DOMContentLoaded event
        document.addEventListener("load", ready, false);
        // backup is window load event
        window.addEventListener("DOMContentLoaded", ready, false);
      } else {
        // must be IE
        document.attachEvent("onreadystatechange", readyStateChange);
        window.attachEvent("onload", ready);
      }
      readyEventHandlersInstalled = true;
    }
  };
})("docReady", window);
// modify this previous line to pass in your own method name
// and object for the method to be attached to

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class DomHelper {
  constructor() {}
  getSiblings(element, filter) {
    var includeSelf =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var siblings = [];
    var currentElement = element;

    // Do the previous first
    while ((currentElement = currentElement.previousElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    if (includeSelf) {
      siblings.push(element);
    }

    // Then the next side
    currentElement = element;

    while ((currentElement = currentElement.nextElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    return siblings;
  }

  nodeListToArray(nodeList, filter) {
    var items = [];

    for (var i = 0; i !== nodeList.length; ++i) {
      if (!filter || nodeList[i].matches(filter)) {
        items.push(nodeList[i]);
      }
    }

    return items;
  }
  outerWidthWithMargin(element) {
    var width = element.offsetWidth,
      style = getComputedStyle(element);

    width += parseInt(style.marginLeft) + parseInt(style.marginRight);

    return width;
  }
  outerHeightWithMargin(element) {
    var height = element.offsetHeight,
      style = getComputedStyle(element);

    height += parseInt(style.marginTop) + parseInt(style.marginBottom);

    return height;
  }
}

class Responsive {
  constructor() {
    var _this = this;

    this.currentBreakpoint = this.getCurrentBreakpoint();

    window.addEventListener("resize", function () {
      var newBreakpoint = _this.getCurrentBreakpoint();

      if (_this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent("breakpoint:changed", {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        })
      );

      _this.currentBreakpoint = newBreakpoint;
    });
  }

  matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
      case "phone":
        return window.matchMedia("screen and (max-width: 640px)").matches;

      case "tablet":
        return window.matchMedia(
          "screen and (min-width: 641px) and (max-width: 1025px)"
        ).matches;

      case "tablet-and-up":
        return window.matchMedia("screen and (min-width: 768px)").matches;

      case "pocket":
        return window.matchMedia("screen and (max-width: 1025px)").matches;

      case "lap-and-up":
        return window.matchMedia("screen and (min-width: 1025px)").matches;

      case "desk":
        return window.matchMedia("screen and (min-width: 1280px)").matches;

      case "widescreen":
        return window.matchMedia("screen and (min-width: 1600px)").matches;
    }
  }
  getCurrentBreakpoint() {
    if (window.matchMedia("screen and (max-width: 640px)").matches) {
      return "phone";
    }

    if (
      window.matchMedia("screen and (min-width: 641px) and (max-width: 1024px)")
        .matches
    ) {
      return "tablet";
    }

    if (
      window.matchMedia(
        "screen and (min-width: 1008px) and (max-width: 1279px)"
      ).matches
    ) {
      return "lap";
    }

    if (window.matchMedia("screen and (min-width: 1280px)").matches) {
      return "desk";
    }
  }
}
class RevolutionImage {
  constructor() {}

  getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return src.replace(/http(s)?:/, "");
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|webp|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
    } else {
      return null;
    }
  }
  getSupportedSizes(image, desiredSizes) {
    var supportedSizes = [],
      imageWidth = image["width"];

    desiredSizes.forEach(function (width) {
      if (imageWidth >= width) {
        supportedSizes.push(width);
      }
    });

    return supportedSizes;
  }
}

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }
    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.$el[0],
          },
        })
      );
    });
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.breakpoint = new Responsive().getCurrentBreakpoint();


    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () {};
    this.onClose = options["onClose"] || function () {};
    this.isOpen = false;

    this.bindEvents();

  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );

      this.delegateBody.on("keydown", onEscape((event) => {
        // Only close this drawer if it's currently open
        if (this.isOpen) {
          console.log("escape pressed");
          event.stopPropagation();
          this.closeDrawer(event);
        }
      }));

    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    
    window.addEventListener("resize", this.calculateMaxHeightListener);
  }

  maxHeight() {
         

    this.element.style.height = window.innerHeight + "px";
  
   if (
      this.element.getAttribute("id") == "cart" ||
      this.element.getAttribute("id") == "sidebarFavorites"
    ) {
      var footer = this.element.querySelector(".CartDrawer--Footer");
      var footerHeight = 0;
      if (footer !== null) {
        footerHeight = footer.offsetHeight;
      }

      var headerEl = this.element.querySelector(".CartHeader");
      if(headerEl){
       var header =  headerEl.offsetHeight
      }
      var cartItem = this.element.querySelector(".cartItem");
      if (cartItem !== null) {
        var itemHeight = cartItem.offsetHeight;
      }

      var itemWrapper = this.element.querySelector(".CartItems--Wrapper");

      if (itemWrapper !== null) {
        itemWrapper.style.height =
          window.innerHeight - footerHeight - header + "px";
      }
    }


  }

  toggleDrawer() {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {    
    
    this.element.dispatchEvent(new CustomEvent('closeSearch', { bubbles: true }));
    if (this.element.getAttribute("id") == "cart") {

          this.element.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
            setTimeout(() => {
        var count = window.theme.cartCount;
        var options = JSON.parse(this.element.getAttribute("data-settings"));
        if(options['showRecommendations'] && count > 0){
          this.element
              .querySelector(".CartDrawer--Expendable")
              .setAttribute("aria-expanded", true);
        }
            }, 200);
    }

      if (this.isOpen) {
          return;
      }


      this.maxHeight();
      if (this.element.getAttribute("id") == "sidebarDrawer") {
       
        var MobileColor3 = document.querySelector('.HamburgerItem');
        MobileColor3.classList.add('red');
        
        document.querySelector(".SidebarDrawer__Close").style.display = "block";
        this.element.dispatchEvent(
          new CustomEvent("sidebar-drawer:open", {
            bubbles: true,
          })
        );
      } else if (this.element.getAttribute("id") == "favoritesDrawer") {
        this.element.dispatchEvent(
          new CustomEvent("favorite-product:open", {
            bubbles: true,
          })
        );
      }
      this.element.setAttribute("aria-expanded", "true");
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this._closeListener);
      var focus = this.element.querySelectorAll('[data-scrollable]');
      focus.forEach((item) =>{
        bodyScrollLock.disableBodyScroll(item);
      });
      document.body.classList.add('scrollLock');
      this.isOpen = true;
      trapFocus(this.element);
      this.onOpen();
      return false;

  }
  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    if (this.element.getAttribute("id") == "sidebarDrawer") {
      document
      .querySelector("#sidebarDrawer")
      .setAttribute("aria-expanded", false);
    }
    document.body.classList.remove("scrollLock");

    
    if (this.element.getAttribute("id") == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
      if (options["showRecommendations"]) {
        this.element
          .querySelector(".CartDrawer--Expendable")
          .setAttribute("aria-expanded", false);
        setTimeout(() => {
          this.element.querySelector(".CustomCart__Recommendations").innerHTML =
            "";
        }, 800);
      }
      document
      .querySelector("#cart")
      .setAttribute("aria-expanded", false);
    }
  
    this.pageOverlayElement.classList.remove("is-visible");
    this.element.setAttribute("aria-expanded", "false");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    removeTrapFocus(this.element);
    this.closeAnimation(this.element);
    this.isOpen = false;
    this.onClose();
    bodyScrollLock.clearAllBodyScrollLocks();
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      var contentToAnimate = this.element.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.setupAnimation(item, i);
      });
    }
  }
  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  elementScaleOut(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(104%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }
  setupAnimation(animatedItem, i) {
    var options = [],
      query = "";
    options["integer"] = i;
    options["type"] = animatedItem.getAttribute("data-animation");

    var _this = this;
    if (this.intersectionObserver[i]) {
      this.intersectionObserver[i].disconnect();
    }
    this.intersectionObserver[i] = new IntersectionObserver(
      this.reveal.bind(this, options),
      {
        threshold: 0.3,
      }
    );
    if (window.theme.enableImageAnimations) {
      query = ".animatedContent";
    }
    new DomHelper()
      .nodeListToArray(
        animatedItem.querySelectorAll(".animatedContent, .animatedContent")
      )
      .forEach(function (item) {
        _this.intersectionObserver[i].observe(item);
      });
  }

  reveal(a, results) {
    var _this = this;
    var integer = a["integer"];
    var toReveal = [];
    results.forEach(function (result) {
      if (result.isIntersecting || result.intersectionRatio > 0) {
        // isIntersecting does not exist on Samsung Android browser
        toReveal.push(result.target);
        _this.intersectionObserver[integer].unobserve(result.target);
      }
    });

    if (toReveal.length === 0) {
      return;
    }

    switch (a["type"]) {
      case "elementFromTop":
        this.elementFromTop(toReveal);
        break;

      case "elementFromBottom":
        this.elementFromBottom(toReveal);
        break;

      case "elementFromRight":
        this.elementFromRight(toReveal);
        break;

      case "elementFromLeft":
        this.elementFromLeft(toReveal);
        break;
      case "elementFromLeftBig":
        this.elementFromLeftBig(toReveal);
        break;
      case "elementFromRightBig":
        this.elementFromRightBig(toReveal);
        break;
      case "elementScaleIn":
        this.elementScaleIn(toReveal);
        break;
      case "elementScaleOut":
        this.elementScaleOut(toReveal);
    }
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.counter = 0;
    this.counter = this.element.querySelector(".counter");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    const countInterval = setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const countDate = new Date(
      "March 3, 2030," + this.options["countdownTime"]
    );
    const nOfDays = this.options["countdownDays"];
    const difference = countDate - dateNow;

    var textDays = 0;
    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;
    const todaysDay = dateNow.getDay();

    const textHours = Math.floor((difference % days) / hours);
    const textMinutes = Math.floor((difference % hours) / minutes);
    const textSeconds = Math.floor((difference % minutes) / seconds);

    if (todaysDay == 1) {
      textDays = nOfDays;
    } else if (todaysDay == 0) {
      textDays = 0;
    } else {
      textDays = nOfDays - todaysDay;
      if (textDays < 0) {
        const mDays = todaysDay % nOfDays;
        textDays = nOfDays - mDays;
      }
    }

    if (this.options["excludeWeekends"] && todaysDay == 5) {
      textDays = textDays + 2;
    } else if (this.options["excludeWeekends"] && todaysDay == 6) {
      textDays = textDays + 1;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;
    if (textDays > 0 && nOfDays > 1) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}
customElements.define("countdown-element", Countdown);


class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.loader = this.element.querySelector(".itemLoader");
    this.cartCount = document.querySelector(".CartCount");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    
    new Popup(this.element);

    new AddToCart(this.element);
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.bindEvents();
  }
  onUnload() {
    this.delegateElement.off();
    document.removeEventListener("product:added", this.onProductAddedListener);
  }
  bindEvents() {

    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
      document.addEventListener("product:added", this.onProductAddedListener);
      document.addEventListener("cart:rerender", this.renderCart.bind(this));
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        ".QuantitySelector__CurrentQuantity",
        this.updateItemQuantity.bind(this)
      );

      window.theme.listener = "true";
    }
  }
  onOpen() {
    
    if (this.element.getAttribute("aria-expanded") == "false") {
      document.documentElement.style.setProperty(
        "--cartHeader-height",
        document.querySelector(".CartHeader").offsetHeight + "px"
      );
      if (this.options["showRecommendations"]) {
        const isMobile = new Responsive().matchesBreakpoint("pocket");
        if (isMobile) {
          this.loadRecommendationsMobile();
        } else {
          this.loadRecommendations();
        }
      }
    }
  }
  updateItemQuantity(event, target) {
    if (window.location.href.indexOf("/cart") > -1) {
      return;
  }
    event.preventDefault();
    target
      .closest(".cartItem")
      .querySelector(".itemLoader")
      .classList.add("is-visible");
    var _this = this;

    var quantity = null,
      elementToAnimate = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"));
    }

    console.log(JSON.stringify({
      id: target.getAttribute("data-line-id"),
      quantity: quantity,
    }));
    

    fetch(window.routes.localeRootUrl + "/cart/change.js", {
      body: JSON.stringify({
        id: target.getAttribute("data-line-id"),
        quantity: quantity,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (content) {
     
      _this.renderCart(target.getAttribute("data-id"), true);
    });

  }

  onProductAdded() {
    var _this = this;
    this.renderCart().then(function () {
      _this.sidebarDrawer.openDrawer();
    });
  }

  renderCart(lineNumber, quantityChange) {
    this.pageLoader.style.width = 100 + "%";

    var _this = this;
    return fetch(window.routes.localeRootUrl + "/?section_id=cart-drawer", {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(html, lineNumber, quantityChange);
      });
    });
  }

  replaceContent(html, lineNumber, quantityChange) {
    var _this = this;
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = 0 + "px";
    this.pageLoader.style.width = 0 + "%";
    setTimeout(() => {
      this.pageLoader.style.left = 0 + "px";
      this.pageLoader.style.right = "unset";
    }, 550);
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    this.tempOptions = JSON.parse(
      tempElement.querySelector("#cart").getAttribute("data-settings")
    );


    const carted_products = tempElement.querySelector('cart-drawer').dataset.carted;
    sessionStorage.setItem('carted_products', carted_products);

    this.element.dispatchEvent(
      new CustomEvent("quantity:changed", { bubbles: true })
    );

    this.tempOptions = JSON.parse(tempElement.querySelector('#cart').getAttribute("data-settings"));

    var number = this.tempOptions['itemCount'];
    this.cartCount.innerHTML = "(" + number + ")";
     window.theme.cartCount = parseInt(number);

    // Track if an item was completely removed
    let itemWasRemoved = false;

    if (lineNumber) {
      var cartNodeParent = this.element.querySelector("#" + lineNumber);
      const itemToReplaceWith = tempElement.querySelector(
        "#" + lineNumber + " .cartItem--Informations"
      );
      if (cartNodeParent.querySelector(".itemLoader")) {
        cartNodeParent
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
      }
      if (itemToReplaceWith) {
        cartNodeParent.replaceChild(
          itemToReplaceWith,
          cartNodeParent.querySelector(".cartItem--Informations")
        );
      } else {

        // Item was completely removed
        itemWasRemoved = true;

        cartNodeParent.classList.add("removing");
        cartNodeParent.animate(
          [
            // keyframes
            { transform: "translateY(0px)", opacity: "1" },
            { transform: "translateY(30px)", opacity: "0" },
          ],
          {
            // timing options
            duration: 500,
            fill: "forwards",
          }
        );
        setTimeout(() => {
          cartNodeParent.remove();
        }, 500);
      }
      if (number > 0) {
        const checkoutButtonParent = this.element.querySelector(
          "age-verification"
        );
        const checkoutButtonToReplace = tempElement.querySelector(
          ".cartCheckout--Button"
        );

        const subtotalToReplace = tempElement.querySelector('.MetaIcon--Wrappers');
        const subtotalButtonParent = this.element.querySelector('.CartDrawer--Footer');
        subtotalButtonParent.replaceChild(
          subtotalToReplace,
          subtotalButtonParent.querySelector(".MetaIcon--Wrappers")
        );
 

      } else {

        this.element
          .querySelector(".CartDrawer--Footer")
          .classList.add("removing");

        const mainPartParent = this.element.querySelector(".CartDrawer");

        mainPartParent.innerHTML =
          tempElement.querySelector(".CartDrawer").innerHTML;
          if(this.options['showRecommendations']){
            if (this.breakpoint == "pocket") {
             this.loadRecommendationsMobile();
            }else{
    
              this.loadRecommendations();
            }
            this.element
              .querySelector(".CartDrawer--Expendable")
              .setAttribute("aria-expanded", false);
          }
        if (window.theme.enableImageAnimations) {
          const mainPartchildren = mainPartParent.querySelector(
            "#main-cartItems"
          );
   
          mainPartchildren.animate(
            [
              // keyframes
              { opacity: "0" },
              { opacity: "1" },
            ],
            {
              // timing options
              duration: 500,
              fill: "forwards",
            }
          );
        }
      }
      if (this.element.querySelector(".itemLoader")) {
        setTimeout(() => {
          this.element
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
        }, 250);
      }
    } else {
      const cartNodeParent =
        this.element.querySelector(".CartDrawer").parentNode;
      const currentScrollPosition =
        this.element.querySelector("#main-cartItems").scrollTop;

      cartNodeParent.replaceChild(
        tempElement.querySelector(".CartDrawer"),
        this.element.querySelector(".CartDrawer")
      );
      this.element.querySelector("#main-cartItems").scrollTop =
        currentScrollPosition;
      if (window.theme.enableImageAnimations) {
        new RevolutionAnimation(this.element);
      }
    }

    setTimeout(() => {

      if (this.options["showRecommendations"] && (itemWasRemoved || !quantityChange)) {
        if (this.breakpoint == "pocket") {
          this.loadRecommendationsMobile();
        } else {
          this.loadRecommendations();
        }
      }
      var focus = _this.element.querySelector(".CartItems--Wrapper[data-scrollable]");
      console.log(focus)
      bodyScrollLock.disableBodyScroll(focus);
      _this.sidebarDrawer.maxHeight();
      
    new CustomEvent("cart:rerendered", {
      bubbles: true
    })
    }, 220);

  }

  loadRecommendations() {

    if(this.options['productId'] == ''){
      var url =
          "?section_id=cart-recommendations";
    }else{
      var url =
          "/recommendations/products?section_id=cart-recommendations&product_id=" +
          this.options["productId"] +
          "&limit=8";
    }

    var _this = this;
    return fetch(url).then(function (response) {
        return response.text().then(function (content) {
            var container = document.createElement("div");
            container.innerHTML = content;
            var z = container.querySelector(".cartUpsell").innerHTML;
            if (window.theme.cartCount == 0) {
              var x = _this.element.querySelector(".EmptyRecommendations");
              x.innerHTML = z;
              var id = container.querySelector('section').dataset.sectionid;
     

              const swiper = new Swiper(".EmptyRecommendations .swiperUpsell", {
             //    Default parameters
             "slidesPerView": 1.9162,
             "spaceBetween": 16,
             "preloadImages": true,
             "lazy": false,
             "slidesOffsetAfter": 0,
             "slidesOffsetBefore": 0,
             "pagination": {
               "el": ".collection-pagination"
             },
             "breakpoints":{
              "1025":{
                "slidesOffsetAfter": 32,
                "slidesOffsetBefore": 32
              }
             }
             
              });
           
            } else {
              var x = _this.element.querySelector(".withItemRecommendations");
              x.innerHTML = z;

            }


            new AddToCart(x);
            bodyScrollLock.disableBodyScroll(_this.element.querySelector('.CustomCart__Recommendations[data-scrollable]'));

                if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
                  new RevolutionAnimation(_this.element);
                }



        })
        .catch(e => {
          console.error(e);
        });
    });

}

  loadRecommendationsMobile() {

    if(this.options['productId'] == ''){
      var url =
          "?section_id=cart-recommendations";
    }else{
      var url =
          "/recommendations/products?section_id=cart-recommendations&product_id=" +
          this.options["productId"] +
          "&limit=8";
    }

    var _this = this;
    return fetch(url).then(function (response) {
        return response.text().then(function (content) {
            var container = document.createElement("div");
            container.innerHTML = content;
            var z = container.querySelector(".cartUpsell").innerHTML;
            var id = container.querySelector('section').dataset.sectionid;


              var x = _this.element.querySelector(".EmptyRecommendations");
              x.innerHTML = z;

              const swiper = new Swiper(".swiperUpsell", {
            //    Default parameters
            "slidesPerView": 1.9162,
            "spaceBetween": 16,
            "preloadImages": true,
            "lazy": false,
            "slidesOffsetAfter": 32,
            "slidesOffsetBefore": 16,
            "pagination": {
              "el": ".collection-pagination"
            }
            
              });



            new AddToCart(x);

                if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
                  new RevolutionAnimation(_this.element);
                }



        })
        .catch(e => {
          console.error(e);
        });
    });

  }
}
customElements.define("cart-drawer", CartDrawer);


class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.bindEvents();
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
    new AddToCart(this.element);
  }

  bindEvents() {
    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.carousel = new RevolutionSwiper(this.carouselElement);
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
      this.createObserver();
    } else {
      this.createObserver();
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    var breakpoint = new Responsive().getCurrentBreakpoint();

    if (singleItem == true) {
      var imageContainers = this.element.querySelectorAll(
        ".Banner__ImageContainer--Swap"
      );
    } else {
      var currentIndex = this.carousel.swiperElement.activeIndex;
      var domHelper = new DomHelper();
      var cellElement = this.carousel.swiperElement.slides[currentIndex];
      var imageContainers = domHelper.nodeListToArray(
        cellElement.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    }
    if (imageContainers.length === 0) {
      return;
    }
    var imageToReveal = null;

    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0].querySelector(".Banner__Image");
    } else {
      imageToReveal = imageContainers[1].querySelector(".Banner__Image");
    }
    if (
      imageToReveal &&
      imageToReveal.getAttribute("data-loaded-image") != true
    ) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");

      imageToReveal.src = replaceUrl;
      imageToReveal.setAttribute("data-loaded-image", "true");
    }
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.carousel = this.element.querySelectorAll(".MenuSlideshow");
    var selectBoxes = this.element.querySelectorAll(".RevolutionDropdown");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    this.domHelper = new DomHelper();

    if (this.options.sticky) {
      this.toggleSticky();
    }
    this.bindEvents();
    this.menuOverlapHandler();

  }

  menuOverlapHandler() {
    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    var menuItems = this.element.querySelector(".Header--MenuItems"),
      overlapping = false,
      menuWrapper = this.element.querySelector(".HeaderWrapper"),
      allHeights = [],
      _this = this;
    if (menuItems) {
      var desiredHeight = _this.element.querySelectorAll(".mainLinks");
      desiredHeight.forEach((item, i) => {
        allHeights.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(null, allHeights);
      var minHeight = Math.min.apply(null, allHeights);
      if (maxHeight > minHeight) {
        overlapping = true;
        if (
          window.theme.menuBreakpoint == 0 ||
          window.theme.menuBreakpoint == undefined
        ) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }
    if (currentClientWidth > window.theme.menuBreakpoint) {
      menuItems.classList.remove("mt-m");
      menuWrapper.querySelector(".mainMenuItems").prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add("mt-m");
      menuItems.closest(".header").appendChild(menuItems);
    }
    document.documentElement.style.setProperty(
      "--header-height",
      _this.element.clientHeight + "px"
    );
  }

  toggleSticky() {
    this.element.parentElement.classList.add("Header--Sticky");
    this.element.parentElement.classList.remove("Header--Transparent");
  }

  bindEvents() {
    const _this = this;
    document.addEventListener("shopify:section:load", function() {
      _this.menuOverlapHandlerListener();
    });
    window.addEventListener("resize", this.menuOverlapHandlerListener);
    this.toggleColorListener = this.toggleColor.bind(this);
    this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
    window.addEventListener("scroll", this.toggleColorListener);

    this.delegateElement.on(
      "mouseenter",
      "[aria-haspopup='true']",
      this.openMenu.bind(this), true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-haspopup='true']",
      this.openMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-submenu]",
      this.closeMenu.bind(this), true
    );

     this.delegateElement.on("keydown", onEscape((event) => {
       this.closeMenu(event);
    })
    )

    this.delegateElement.on(
      "mouseenter",
      "[aria-haspopup='false']",
      this.closeMenu.bind(this), true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-haspopup='false'], .mainLinks",
      this.closeMenu.bind(this), true
    );
  }

  openMenu(event, target) {

    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    if (event.type === "mouseenter" && target !== event.target) {return;}

    this.element.classList.remove("Header--Transparent");
    target.setAttribute("aria-expanded", "true");

    this.domHelper
      .getSiblings(target, '[aria-expanded="true"]')
      .forEach(function (item) {
        item.setAttribute("aria-expanded", "false");
      });

      bodyScrollLock.disableBodyScroll(
        this.element.querySelector("[data-scrollable]"), bodyScrollLockOptions
        );
  }

  closeMenu(event, target) {


    if (event.type === "mouseleave" && target !== event.target){return;}


    if (this.options["transparent"]) {
      this.element.classList.add("Header--Transparent");
    }

    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach(function (item) {
        item.setAttribute("aria-expanded", "false");
    });
    bodyScrollLock.clearAllBodyScrollLocks();
  }

  toggleColor() {

    if (this.options.transparent) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove("Header--Transparent");
      } else {
        this.element.classList.add("Header--Transparent");
      }
    }
  }
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.SidebarMenu = new Drawer(this.element);
    this.dropdown = new Dropdown(this.element);
    this.carouselElement = this.element.querySelector(".mobileMenu--upsell");
    if (this.carouselElement) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
    this.bindEvents();
  }
  bindEvents() {
    document.addEventListener("sidebar-drawer:open", this.onDrawerListener);
  }

}
customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
var trans = new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;

    if (this.options["using_fade"] == "fade") {
      var childOfSlide = this.element.closest(".swiper-slide");
      if (childOfSlide) {
        if (
          this.element.dataset.position == 0 ||
          childOfSlide.classList.contains("swiper-slide-active") ||
          childOfSlide.classList.contains("swiper-slide-duplicate-active")
        ) {
          this.checkLoaded();
          this.bindEvents();
        } else {
          this.bindEvents();
        }
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }


    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();
    const isMobile = breakpoint === "phone" || breakpoint === "tablet";


    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options['videoRatio'];
        }
        src = topQuality['url'] + "#t=0.001";
      } else if (this.options["videoType"] == 'video_inside_media_external') {
        const aspectRatioHeight = Math.floor(100 / this.options["videom"]["aspect_ratio"]);
        if (!this.options['videoRatio']) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options['videoRatio'];
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";
      if (this.options["videoType"] == 'video_inside_media') {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options['videoRatio'];
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options['videoRatio'];
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const posterUrl =
      this.options["plh"] &&
      (isMobile ? this.options["plh_mob"] : this.options["plh_desk"]);
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: posterUrl || false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        children: [
          "playToggle",
          "progressControl",
          "currentTimeDisplay",
          "timeDivider",
          "durationDisplay",
          "CustomControlSpacer",
          "VolumePanel"
        ],
      },

      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    if (videoplayerID) this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }
    });

    if (this.options['muted'] && host == 'vimeo') {
      this.videoPlayer.on('play', function () {

        _this.videoPlayer.muted("true");
      })
    }

    if (this.options["controls"]) {
      const playPauseToggle = function (e) {
        if (e.target.closest('.vjs-control-bar')) {
          return;
        }
        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      };
      this.videoPlayer.on("touchstart", function (e) {
        e.preventDefault();
        playPauseToggle(e);
      });
      this.videoPlayer.on("click", playPauseToggle);
    }

    const volumeControl = this.element.querySelector('.vjs-volume-panel');
    const progressControl = this.element.querySelector('.vjs-progress-control');
    volumeControl.addEventListener('mouseenter', () => this.element.dispatchEvent(new CustomEvent('banner:disable', { bubbles: true })));
    volumeControl.addEventListener('mouseleave', () => document.dispatchEvent(new CustomEvent('banner:enable', { bubbles: true })));
    progressControl.addEventListener('mouseenter', () => this.element.dispatchEvent(new CustomEvent('banner:disable', { bubbles: true })));
    progressControl.addEventListener('mouseleave', () => document.dispatchEvent(new CustomEvent('banner:enable', { bubbles: true })));
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {

      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {

        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {

          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }
          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
      this.dropdown = new Dropdown(this.element);
    }

    requestAnimationFrame(()=>{
      this.footerDropdownButtons = this.element.querySelectorAll(".DropdownButton");
      this.footerDropdownContent = this.element.querySelectorAll(".DropdownContent");

      if(breakpoint == "desk" || breakpoint == "lap"){
        this.footerDropdownButtons.forEach(button =>{
          button.setAttribute("aria-expanded", "true")
        })

        this.footerDropdownContent.forEach(content=>{
          content.setAttribute("aria-hidden","false")
        })
      }

    })
    this.bindEvents();
  }

  bindEvents() {
   setTimeout(()=>{
    this.handleChatTab();
   },500);
   
   document.addEventListener("keydown", onEnter(event =>{
    const button = event.target.shadowRoot.querySelector("button[data-spec='toggle-button']");
    if(button){
      button.click();
    }
   }))
   document.addEventListener("keydown", onEscape(event =>{
    const button = event.target.shadowRoot.querySelector("button.chat-app--close-button");
    if(button){
      button.click();
    }
   }))
  }

  handleChatTab(){
    const chatTab = document.querySelector("inbox-online-store-chat");
    chatTab.setAttribute("tabindex","0");
  }
}
customElements.define("footer-component", FooterComponent);

class DropdownSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.dropdown = new Dropdown(this.element);
  }
}
customElements.define("dropdown-section", DropdownSection);

class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.delBody = new Delegate(document.body);
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(
      ".ProductSlider--Thumbnails"
    );
    
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    // Initialize swiper if element exists and has slides
    // Initialize even with 1 slide for features like zoom, navigation, etc.
    if(this.carouselElement && this.options['slides_number'] > 0){
      if(this.options['show_thumbnails'] && this.carouselElementThumbs){
        this.carousel = new RevolutionSwiper(
          this.carouselElement,
          this.carouselElementThumbs
        );
      } else {
        this.carousel = new RevolutionSwiper(
          this.carouselElement
        );
      }
    }

    // Set up autoplay handling during resize
    this.setupAutoplayResize();

    this.changeImageQuality();
    this.valuesWrap = this.element.querySelectorAll(
      ".ProductOption--ValusWrapper"
    );
    var localPickup = this.element.querySelector("#LocalPickup");
    if (localPickup) {
      new Drawer(this.querySelector("#LocalPickup"));
    }
    // Always bind AJAX add-to-cart submit fallback.
    // Without this, some PDP forms can fall back to a normal POST to `/cart/add` and redirect to `/cart`.
    new AddToCart(this.element);

    new Dropdown(this.element.querySelector(".ProductInfo--Wrapper"));

    // Initialize set product swiper
    const setSwiper = this.element.querySelector(".main-product__set-wrapper.swiper");
    if (setSwiper) {
      new RevolutionSwiper(setSwiper);
    }

    var selectBoxes = this.element.querySelectorAll(".RevolutionDropdown");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.element, this.carousel);
    }

    this.bindEvents();
    this.handleDeliveryIconsBlock();
  }

  handleDeliveryIconsBlock(){
    const previousBlock = this.element.querySelector(".ProductActions");
    const parent = document.createElement('div');
    const children = this.element.querySelectorAll('.main-product__usp-delivery');

    previousBlock.parentNode.insertBefore(parent, previousBlock.nextSibling);

    if(children.length === 0) return;
    parent.classList.add("main-product__usp-delivery-container");

    children.forEach(child =>{
      parent.appendChild(child);
    });

  }
  // Handle autoplay during resize
  setupAutoplayResize() {
    let resizeTimer;
    let wasAutoplaying = false;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      
      // On resize start - pause autoplay if it's running
      if (this.carousel && this.carousel.swiperElement && this.carousel.swiperElement.autoplay) {
        wasAutoplaying = this.carousel.swiperElement.autoplay.running;
        
        if (wasAutoplaying) {
          this.carousel.swiperElement.autoplay.stop();
        }
      }
      
      // Add a CSS class to disable transitions during resize
      if (this.carouselElement) {
        this.carouselElement.classList.add('swiper-no-transition');
      }
      
      resizeTimer = setTimeout(() => {
        // Remove transition disabling class
        if (this.carouselElement) {
          this.carouselElement.classList.remove('swiper-no-transition');
        }
        
        // Update the Swiper instance
        if (this.carousel && this.carousel.swiperElement && typeof this.carousel.swiperElement.update === 'function') {
          this.carousel.swiperElement.update();
        }
        
        // After resize completes, restore autoplay if it was running before
        if (this.carousel && this.carousel.swiperElement && this.carousel.swiperElement.autoplay && wasAutoplaying) {
          setTimeout(() => {
            this.carousel.swiperElement.autoplay.start();
          }, 100);
        }
      }, 250);
    });
  }

  bindEvents() {
    this.domDelegate.on("variant:changed", this.updateImage.bind(this));

    this.delBody.on("keydown",".ProductSlider--Thumb", onEnter((event) => {
      this.handleImageTabbing(event);
    }));


    this.domDelegate.on(
      "click",
      "[data-action='share-product']",
      this.shareProduct.bind(this)
    );
  }

  shareProduct(event) {
    event.preventDefault();
    const title = this.element.querySelector(".ProductInfo--Title h1, .ProductInfo--TitlePrice h1")?.textContent?.trim() || document.title;
    const url = window.location.href;
    const shareData = { title, url };

    if (navigator.share) {
      navigator.share(shareData).catch((err) => {
        if (err.name !== "AbortError") this.fallbackCopyShare(url);
      });
    } else {
      this.fallbackCopyShare(url);
    }
  }

  fallbackCopyShare(url) {
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(url).then(() => {
        this.showShareFeedback(true);
      }).catch(() => {
        this.showShareFeedback(false);
      });
    } else {
      this.showShareFeedback(this.legacyCopyToClipboard(url));
    }
  }

  legacyCopyToClipboard(text) {
    const input = document.createElement("input");
    input.value = text;
    input.setAttribute("readonly", "");
    input.style.position = "absolute";
    input.style.left = "-9999px";
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, text.length);
    let ok = false;
    try {
      ok = document.execCommand("copy");
    } catch (e) {}
    document.body.removeChild(input);
    return ok;
  }

  showShareFeedback(success) {
    const btn = this.element.querySelector("[data-action='share-product']");
    if (!btn) return;
    const msg = success ? "Link copied" : "Copy failed";
    const prev = btn.getAttribute("aria-label");
    btn.setAttribute("aria-label", msg);
    setTimeout(() => btn.setAttribute("aria-label", prev || "Share product"), 2000);
  }


  handleImageTabbing(event) {
    const thumbContainer = event.target.closest('.ProductSlider--Thumb');

    if (thumbContainer && this.carousel && this.carousel.thumbSwiper) {
      // Get the index of the clicked thumbnail slide
      const slides = Array.from(this.carousel.thumbSwiper.slides);
      const slideIndex = slides.indexOf(thumbContainer);

      if (slideIndex !== -1) {
        // Navigate the main carousel to this index
        this.carousel.selectCell(slideIndex);
      }
    }
  }

  updateImage() {
    var imageID = event.detail.new_image;
    var selector = "#Image--" + imageID;
    var imageIndex = this.element
      .querySelector(selector)
      .getAttribute("data-image-position");
    this.carousel.selectCell(parseInt(imageIndex));
  }

  changeImageQuality() {
    var imageToReveal = null;
    imageToReveal = this.element.querySelector(
      ".ProductSliderCell:first-child img"
    );
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }
}

customElements.define("product-component", ProductElement);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.bindEvents();
  }

  bindEvents(){
    this.delegateBody.on("quantity:changed", (event)=>{
      event.stopImmediatePropagation();
      this.onVariantChange(event);
    });

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updatePickupAvailability();
    this.updatePrice();
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;


    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }


  updateVariantInput() {
    if(this.currentVariant){
      const productForms = document.querySelectorAll(
        `#product-form-${this.productID}, #product-form-installment`
      );
  
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }
  
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    if(this.currentVariant){
      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const id = ".ProductInfo--Prices";
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const destination = document.querySelector(id);
          const source = html.querySelector(id);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
  
          this.toggleAddButton();
        });
    }
 
  }

  toggleAddButton() {
    const addButton = document.querySelector(".ProductPage--ATC"),
          addButtonInner = addButton.querySelector(".SelfAlign"),
          quantity = document.querySelector('.QuantitySelector__ProductQuantity').value;
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }
  
    if (!addButton) return;
    if (!quantity){quantity = 1;}

    if (this.currentVariant.available == false) {
      addButton.setAttribute("disabled", "disabled");
      addButton.classList.add("ProductCard--Sold__Out");
      addButtonInner.innerHTML = buySvg + window.variantStrings.soldOut;
    } else {
      addButton.removeAttribute("disabled");
      addButton.classList.remove("ProductCard--Sold__Out");
      if (window.variantInfo.show_price) {
        var priceElement =
          "<span class='ml-s'>" +
          Shopify.formatMoney(
            this.currentVariant.price * quantity,
            window.theme.moneyFormat
          );
        +"</span>";
      } else {
        var priceElement = "";
      }

      addButtonInner.innerHTML =
        buySvg + window.variantStrings.addToCart + priceElement;
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    this.blogWrapper = this.element.querySelector("#BlogArticleWrapper");
    this.blogElement = this.element.querySelectorAll(".BlogArticle");
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
   
  }
}
customElements.define("blog-section", BlogSection);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.searchElement = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.queryMap = {};
    this.searchResultsElement = this.element.querySelector(".SearchInitial");
    this.pageOverlayElement = document.querySelector(".pageOverlay2");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.searchWrapper = this.element.querySelector(".SearchWrapper");

    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    if (window.theme.showSuggestedSearches) {
      this.getSuggestedSearches();
    }
    this.carouselElement = this.element.querySelector(".SearchCollection");
    if (this.carouselElement) {
      if (new Responsive().matchesBreakpoint("lap-and-up")) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );

    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.bindEvents();
  }


  bindEvents() {
    this._preventSubmissionListener = this.preventSubmission.bind(this);
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateElement.on(
      "click",
      '[data-action="open-search"]',
        this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

     this.delegateElement.on("keydown", onEscape((event) => {
       this.closeSearch(event);
    }));

    this.searchInputElement.addEventListener(
      "keydown",
      this._preventSubmissionListener
    );
    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateBody.on("close:search", (event)=>{
      event.stopImmediatePropagation();
      this.closeSearch(event);

    });
    window.addEventListener("scroll", this.handleSearchHeight.bind(this));

    this.element.addEventListener("DOMContentLoaded", () => {
      this.handleSearchHeight();
    })
  }

  initCarousel() {
    if (new Responsive().matchesBreakpoint("lap-and-up")) {
      var carousel = this.searchResultsElement.querySelector(
        "[data-swiper-settings]"
      );
      if (carousel) {
        this.newCarousel = new RevolutionSwiper(carousel);
      }
    }
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  

  openSearch(event) {
    event.preventDefault();
    if (this.isOpen) {
      this.closeSearch();
      return;
    }
    var _this = this;
    var target = event.target;
    if (
      !this.searchElement.querySelector(".SearchSlide ") &&
      this.options["product"] &&
      this.options["collection"] == ""
    ) {
      this.loadRecommendations();
    }

    target.parentElement
      .querySelector(".SearchWrapper")
      .setAttribute("aria-hidden", false);
      
    this.pageOverlayElement.classList.add("is-visible");
      
    document.body.style.width = "100%";
    this.closeListener = _this.closeSearch.bind(this);
    this.pageOverlayElement.addEventListener("click", _this.closeListener);
    bodyScrollLock.disableBodyScroll(
    this.searchElement.querySelector("[data-scrollable]"),bodyScrollLockOptions
    );
    this.isOpen = true;


    setTimeout(() => {
      _this.searchInputElement.focus();
    }, 200);

    document.body.querySelector("#shopify-section-header").style.zIndex = "99";
    document.body.querySelector("#shopify-section-announcement-bar").style.zIndex = "3";
    if (this.options["transparent"]) {
      setTimeout(() => {
        document.body
          .querySelector("#header")
          .classList.remove("Header--Transparent");
      }, 15);
    }
  
  }

  handleSearchHeight() {
    const annBarHeight = document.querySelector(".announcement-bar").offsetHeight;
    const scrollAnnHeight = annBarHeight - window.scrollY;
    if(new Responsive().matchesBreakpoint("lap-and-up")){
      if(window.scrollY >= annBarHeight ){
        document.documentElement.style.setProperty(
        "--announcement-height", 0 );
        this.searchWrapper.style.top = `calc(var(--header-height))`;
      }else{
              document.documentElement.style.setProperty(
        "--announcement-height", `${scrollAnnHeight}px` );
  
        this.searchWrapper.style.top = "calc(var(--header-height) + var(--announcement-height))";
  
      }
    }
  }

  closeSearch() {
    event.preventDefault();
    var _this = this;
    if (!this.isOpen) {
      return;
    }
    bodyScrollLock.clearAllBodyScrollLocks();
    document.body.querySelector("#shopify-section-header").style.zIndex = "3";
    document.body.querySelector("#shopify-section-announcement-bar").style.zIndex = "3";
    document.body.querySelectorAll(".SearchWrapper").forEach((item, i) => {
      item.setAttribute("aria-hidden", true);
    });
    _this.pageOverlayElement.classList.remove("is-visible");
    document.body.querySelector(
      "#shopify-section-header"
    ).style.backgroundColor = "transparent";
    document.body.style.position = "relative";
    document.body.style.width = "100%";
    if (_this.options["transparent"]) {
      document.body
        .querySelector("#header")
        .classList.add("Header--Transparent");
    }

    this.isOpen = false;
  }

  preventSubmission(event) {
    if (event.keyCode === 13 && window.theme.searchMode !== "product") {
    //  event.preventDefault();
    }
  }

  onInput(event) {

    this.lastInputValue = event.target.value;
    var passTrough = false;
    var _this = this;
    this.searchResultsElement.style.opacity = 0;
    if (event.target.getAttribute("data-value") && _this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = _this.searchElement.querySelector(".SearchInput");
      passTrough = true;
      el.setAttribute("value", _this.lastInputValue);
      el.value = _this.lastInputValue;
    } else {


      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    var queryOptions = {
      method: "GET",
      credentials: "same-origin",
    };
    if (_this.options["suggestedCollections"]) {
      const url = `${window.routes.localeRootUrl}/search/suggest.json?q=${encodeURIComponent(this.lastInputValue)}&resources[type]=collection&resources[limit]=1`;
      var queries = [
        fetch(
          url,
          queryOptions
        )
        ];
    }

    if (window.theme.searchMode !== "product") {
      const url = `${window.routes.localeRootUrl}/search?view=ajax&q=${encodeURIComponent(this.lastInputValue)}*&type=${window.theme.searchMode.replace("product,", "")}`;
      queries.push(
        fetch(
          url,
          queryOptions
        )
      );
    }
    const url = `${window.routes.localeRootUrl}/search?view=ajax&q=${encodeURIComponent(this.lastInputValue)}*&type=product`;
    queries.push (
      fetch(
        url,
        queryOptions
      ),
    );




    this.queryMap[this.lastInputValue] = true;

    Promise.all(queries).then(function (responses) {
      if (_this.lastInputValue !== event.target.value && passTrough == false) {
        return;
      }
      delete _this.queryMap[event.target.value];

      Promise.all(
        responses.map(function (response) {
        return response.text();
        })).then(function (contents) {

        //resultExists determines if there is any other results like products, articles or pages

        var resultExistsObject = [],
          resultExists,
          collectionHTML = document.createElement('div');

          contents.forEach((item, i) => {

            if (item.includes('collections')){
              let collectionInner = '',
                    collectionObject = JSON.parse(item);
              if(collectionObject.resources.results.collections.length > 0){
                collectionHTML.innerHTML = _this.layouts( _this.lastInputValue,false,false,'collectionLayout');
                resultExistsObject.push(true);
                    collectionObject.resources.results.collections.forEach(function (entry) {
                    collectionInner += _this.layouts(entry.url, entry.featured_image.url, entry.title, 'collectionItem');
                  });
                  collectionHTML.querySelector('.Segment__Content').innerHTML = collectionInner;
              }else{
                resultExistsObject.push(false);
                collectionHTML.innerHTML = _this.layouts(false, false, false, 'collectionItemNoResults');
              }

              contents[i] = collectionHTML.innerHTML;

            }else{
              if(item.includes('js-noresult')){
                resultExistsObject.push(false);
              }else{
                resultExistsObject.push(true);
              }

            }
          });

          if(resultExistsObject.includes(true)){
            resultExists = true;
          }else{
            resultExists = false;
          }
        
          if (window.theme.showRecentSearches) {
            _this.recentSearches();
          }

        _this.loadData(resultExists, contents);

      });
    });
  }

  loadData(resultExists, data){

    switch(resultExists){
      case true:

        let content = "";
        let tempContent = "";
        let block = document.createElement('div');
        data.forEach((item, i) => {
          
          if (i < 2) {
            block.innerHTML += item;

          } else {
            tempContent += item;
          }

        });
        content = `<div class="Collection--Article">${block.innerHTML}</div>` + tempContent;
        
      this.searchResultsElement.innerHTML =
      `<div class='SearchLayout--2items'>${content}</div>`

      this.searchResultsElement.style.display = "flex";
      break;

      case false:
        
        let tempElement = document.createElement("div");
            tempElement.innerHTML = data[1];
            
            tempElement = tempElement.querySelector("template").content.firstElementChild.cloneNode(true);


        if (this.options["noResultcollection"]) {
          this.searchResultsElement.innerHTML = this.layouts(tempElement.innerHTML, false, false, 'noResults');
        } else {
          this.searchResultsElement.innerHTML = this.layouts(tempElement.innerHTML, false, false, 'noResultsNoSuggestions');

        }
        this.searchResultsElement.style.display = "flex";
      break;
    }


    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.searchResultsElement);
    }
    this.searchResultsElement.setAttribute("aria-hidden", "false");
    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;


  }

  layouts(string1, string2, string3, type){
    var template = '';
    switch(type){

      case 'collectionLayout':
        template =

        `<div class='SearchLayout__Section--collections SearchLayout__Section--collections--SearchBar' data-animation="elementFromBottom">
          <div class='SearchSegmentHeader SearchSegmentHeader--SearchBar'>
            <span class=' u-h5'>${window.languages.collections}</span>

          </div>
          <div class='Segment__Content u-s4'></div>
        </div>`;
      break;

        case 'collectionItem':
        template =

        `<a href="${string1}" class='SearchCollectionContent'>
              <h5 class='u-s4 mb-l'>${string3}</h5>
            </a>`;
        break;

        case 'collectionItemNoResults':
        template =
        `<div class='searchSegment'>
          <div class="SearchSegmentHeader">
            <span class=" u-h5">${window.languages.collections}</span>
          </div>
          <div class="Segment__Content">
            <p class="SegmentNoResult u-s4 mb-xl">${window.languages.no_results}</p>
          </div>
        </div>`;
        break;

        case 'noResults':
        template =
        `<div class="SearchLayout__Section Search--Recommendations-noResults">${string1}</div>\n`;
        break;

        case 'noResultsNoSuggestions':
        template =
        `<div class="SearchLayout__Section Search--Recommendations-noResultsAll">${string1}</div>\n`;
        break;

    }


    return template;
  }


  loadRecommendations() {
    var _this = this,
      product_to_search = _this.options["product"],
      url =
        window.routes.localeRootUrl +
        "/recommendations/products?section_id=search_suggested&product_id=" +
        product_to_search +
        "&limit=8";

    return fetch(url).then(function (response) {
      return response.text().then(function (content) {
        var container = document.createElement("div");
        var contentjq = document.createElement("div");
        contentjq.innerHTML = content;
        container.innerHTML = contentjq.innerHTML;
        const newSwiper = _this.element.querySelector(
          ".SearchInitial--Products"
        );
        newSwiper.innerHTML = container.querySelector(
          ".ProductRecommendations"
        ).innerHTML;
        _this.initCarousel();
        if (window.theme.enableImageAnimations) {
          new RevolutionAnimation(newSwiper);
        }
        new AddToCart(_this.element);
      });
    });
  }

 resetSearch() {
    let initialProducts = this.searchResultsElement.querySelector(".SearchInitial--Products"),
      initialLayout = this.initialSearchLayout.querySelector(".SearchInitial--Recents");

    this.searchResultsElement.classList.remove("SearchInitial--SecondView");
    this.searchResultsElement.style.display = "";

    if (initialLayout) { initialLayout.style.opacity = 0; }
    if (initialProducts) { initialProducts.style.opacity = 0; }

    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;

    const el = this.searchElement.querySelector(".Search__Form");
    el.value = "";
    el.removeAttribute("value");
    this.searchElement.querySelector(".SearchInput").value = "";
    this.searchResultsElement.setAttribute("aria-hidden", "false");

    if (window.theme.showRecentSearches) { this.getRecentSearches(); }
    if (window.theme.showSuggestedSearches) { this.getSuggestedSearches(); }
    if (this.options["product"] && this.options["collection"] == "") { this.loadRecommendations(); }
    if (window.theme.enableImageAnimations) { new RevolutionAnimation(this.element); }

    initialLayout = this.element.querySelector(".SearchInitial--Recents");
    if (initialLayout) { initialLayout.style.opacity = 1; }
    if (initialProducts) { initialProducts.style.opacity = 1; }

    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
  }

  recentSearches() {
    this.searchResultsElement.style.opacity = 0;


    if (this.lastInputValue === "") {
      this.initialSearchLayout.style.opacity = 0;
      this.resetSearch();
      return;
    }

    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) {}
    }
  }

  getRecentSearches() {
    var appendString = "";
    var items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    var appElement = this.searchElement.querySelector(
      ".Search--Recent__results"
    );
    if (items.length > 0) {
      items.forEach((id, index) => {
        appendString =
          appendString +
          "<li tabIndex='0' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      appElement.innerHTML = appendString;
    } else {
      var appEl = this.searchElement.querySelector(".Search--Recent");
      appEl.style.display = "none";
    }
  }
  getSuggestedSearches() {
    var appendString = "";
    const arr = this.options.items;

    if (arr.length == 0 ){return;}
    arr.sort(function () {
      return 0.5 - Math.random();
    });
    var filtred = arr.filter(function (a) {
      if (!a.includes("_")) {
        return a;
      }
    });

    var i;
    appendString = "";
    for (i = 0; i < 5; i++) {
      if (filtred[i]) {
        var filteredResult = filtred[i].replace(":", " ");
        filteredResult = filteredResult.replace("-", " ");
        appendString =
          appendString +
          "<li tabindex='0' data-action='search-string' data-value='" +
          filteredResult +
          "'>" +
          filteredResult +
          "</li>";
      }
    }
    var appElement = this.searchElement.querySelector(
      ".Search--Suggested__results"
    );
    appElement.innerHTML = appendString;
  }
}
customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

    this.delegateElement.on("keydown", onEnter((event) => {
      const input = event.target.previousElementSibling;
      input.click();
    }))

  }


  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() {}

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup__Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class AnimationWrapper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
  }
}
customElements.define("animation-wrapper", AnimationWrapper);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.domDelegate = new Delegate(document);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.newsletterOpen = false;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.handleOpenOptions();
    if (this.options.edit_mode == true) {
      this.options.delay = 0;
      this.openNewsletter();
    }
   

   this.bindEvents();
  }

  bindEvents(){
    if(new Responsive().matchesBreakpoint("lap-and-up")){
     document.addEventListener("keydown", onEscape((event)=>{
       if (this.newsletterOpen) {
         this.closeNewsletter.bind(this)();
       }
      }));
    }
  }


  handleOpenOptions() {
    let sessionKey = sessionStorage.getItem("popup-seen");
    var localKey = localStorage.getItem("popup-seen");
    if (this.options.show_only_once == true && localKey == "true") {
      return;
    }
    if (sessionKey != "true") {
      if (this.options.scroll_amount > 0) {
        this.scrollListener = this.scrollListener.bind(this);
        document.addEventListener("scroll", this.scrollListener);
      } else {
        this.openNewsletter();
      }
    }
  }

  scrollListener() {
    if (this.newsletterOpen) return; 
    var _this = this,
      body = document.body,
      html = document.documentElement;
    let docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    let percScrolled = (window.scrollY / docHeight) * 100;
    if (percScrolled >= _this.options.scroll_amount) {
      _this.openNewsletter();
    }
  }

  openNewsletter() {
    if (this.newsletterOpen) return;
  this.newsletterOpen = true;
    var _this = this;
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);
      this.pageOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element,bodyScrollLockOptions);
      this.onClickOutsideListener = this.closeNewsletter.bind(this);
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );
      sessionStorage.setItem("popup-seen", true);
      localStorage.setItem("popup-seen", true);
      document.querySelectorAll('[data-action="close-modal"]').forEach((el) => {
        el.removeEventListener('click', this.closeNewsletter); // cleanup
        el.addEventListener('click', this.closeNewsletter.bind(this));
      });
      
      
    }, 1000 * _this.options.delay);
  }

  closeNewsletter() {
    this.newsletterOpen = false;

    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
      this.openTimeout = null;
    }

    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    document.removeEventListener("scroll", this.scrollListener);
  }
}

customElements.define("newsletter-popup", NewsletterPopup);


class FeaturedProduct extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    new AddToCart(this);
  }
}
customElements.define("featuredproduct-wrapper", FeaturedProduct);

class SwiperAll extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.getAttribute("data-settings"));
    new RevolutionSwiper(this.element.querySelector(".swiper"));
  }
}
customElements.define("swiper-wrapper", SwiperAll);


class InstagramSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
      var images = new Array(); 
      var boxes = new Array();
  this.delegateElement = new Delegate(this.element);
  var _this = this;
  var observer = new MutationObserver(function(mutations) {
     if (_this.element.querySelector('.instafeed-container')) {
      var allElements = _this.element.querySelectorAll('.instafeed-container');
      allElements.forEach((item, i) => {
        const img = item.querySelector('img');
        if(img){
              images.push(img.getAttribute('data-src'));
        }
      });
          observer.disconnect();
          _this.element.querySelectorAll('.InstagramImageWrapper').forEach((item, i) => {
            item.querySelector('img').setAttribute('src', images[i]);
          });

          setTimeout(document.querySelector('#insta-feed').style.display = "none", 50);

      }
  });
  observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});
  }
  cleanSelector(selector){
    (selector.match(/(#[0-9][^\s:,]*)/g) || []).forEach(function(n){
        selector = selector.replace(n, '[id="' + n.replace("#", "") + '"]');
    });
    return selector;
  }
}
customElements.define("instagram-section", InstagramSection);

class fromBlog extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
        new RevolutionAnimation(this.element);
      }
      this.delegateElement = new Delegate(this.element);
      this.carouselElement = this.element.querySelector(".swiper");

        let breakpoint = new Responsive().getCurrentBreakpoint();
        if (breakpoint == "phone" || breakpoint == "tablet") {
          new RevolutionSwiper(this.element.querySelector(".swiper"));
        }

    }

  }
  customElements.define("from-blog", fromBlog);

class FormShowBlog extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.formBlog = this.element.querySelector('.comments--form');
    this.bindEvents();
    this.handleAfterState();
  }
  bindEvents(){
    this.delegateElement.on('click', '[data-action="handle-hidden"]', this.toggleEffect.bind(this));
    this.delegateElement.on('click', '[data-action="load-more"]', this.loadMore.bind(this));
    this.delegateElement.on('click', '[data-action="copy"]', this.copy.bind(this));
  }

  copy(){
  var url = document.querySelector("#currentUrl");
  url.value = window.location.href;


  navigator.clipboard.writeText(url.value);

  }

  handleAfterState(){
    if (window.location.href.indexOf("#comment_form") > -1) {
      this.element.querySelector('.comments--buttonWrite').setAttribute('aria-hidden', 'true');
      this.formBlog.classList.remove('comments--formHide');
    }
  }

  toggleEffect(event, target){
    target.setAttribute('aria-hidden', 'true');
    this.formBlog.classList.remove('comments--formHide');
  }

  loadMore(event, target){

    const _this = this;
    let dataHref = target.getAttribute("data-href");


    return fetch(window.routes.localeRootUrl + dataHref, {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (htmlData) {
        let html = new DOMParser().parseFromString(htmlData, "text/html");
        let newComments = html.querySelectorAll('.ArticleComments--Comment');

     let curDocument = _this.element.querySelector('.ArticleComments');
      curDocument.append(...newComments);
        let dataHref = html.querySelector('.comments--buttonFooter');
      
        if(dataHref){
          dataHref = dataHref.dataset.href;
        _this.element.querySelector('.comments--buttonFooter').dataset.href = dataHref;
        }else{
          _this.element.querySelector('.comments--buttonFooter').remove();

        }
      });
    });

  }

}
customElements.define("main-article", FormShowBlog);


class twoSets extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.addstand = false;

    // Initialize AddToCart for the regular ATC button
    new AddToCart(this.element);

    this.bindEvents();
  }


  bindEvents(){
    this.delegateElement.on('click', '[data-action="toggle-options"]', this.toggleOptions.bind(this));
    this.delegateElement.on('click', '[data-action="add-stand"]', this.toggleStand.bind(this));
    this.delegateElement.on('click', '[data-action="choose-stand"]', this.toggleStandOption.bind(this));
    this.delegateBody.on('click', '[data-action="complete-set"]',(event)=>{
      event.preventDefault();
      event.stopImmediatePropagation();
      this.addCompleteSet();
      return false;
    })

    // Prevent form submission when using complete-set button
    document.querySelectorAll('[data-action="complete-set"]').forEach(btn => {
      const form = btn.closest('form');
      if (form) {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          return false;
        });
      }
    });

    this.delegateElement.on("keydown", '[data-action="toggle-options"]',onEnter((event)=>{
      this.toggleOptions(event,event.target);
    }))
  }


  addCompleteSet(){
    this.pageLoader = document.body.querySelector(".pageLoader");
    const addToCartButton = document.querySelector('.floatingATC') || document.querySelector('[data-action="complete-set"]');
    var _this = this;
    const items = []

    // Get or create the completeSet form
    let formElement = document.querySelector('#completeSet');
    if (!formElement) {
      formElement = document.createElement('form');
      formElement.id = 'completeSet';
      formElement.style.display = 'none';
      document.body.appendChild(formElement);
    }

    // If form is empty, get variant from the product form
    if (formElement.querySelectorAll('input').length === 0) {
      const productForm = document.querySelector('[data-type="add-to-cart-form"]');
      const variantInput = productForm?.querySelector('input[name="id"]');
      if (variantInput) {
        const firstInput = document.createElement('input');
        firstInput.type = 'hidden';
        firstInput.id = 'product-variant-1';
        firstInput.name = 'id';
        firstInput.value = variantInput.value;
        formElement.appendChild(firstInput);
      }
    }

    const allInputs = formElement.querySelectorAll('input');

    allInputs.forEach((item) => {
      items.push({
        id: item.value,
        quantity: 1
      })
    });
  

    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify({
        items: items,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true
          })
        );
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
    
  }



  updateOptions(target) {


    this.cid = target.dataset.cid;
    const size = document.querySelector(`input[data-option="Size"][data-cid="${this.cid}"]:checked`).value;
    this.options = [];


    this.options.push(size);
    this.options.push(target.dataset.value);


  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }


  toggleStandOption(event, target){
    const alreadSelected = target.parentElement.querySelector('[aria-selected="true"]');
    if (alreadSelected){
      alreadSelected.setAttribute('aria-selected','false');
    }
    target.setAttribute('aria-selected', true);
    target.closest('.twoSetControl--Raised').querySelector('[data-action="add-stand"]').setAttribute('aria-selected', true);
    

    this.updateOptions(target);
    this.updateMasterId();
  
    const form = document.querySelector('#completeSet');

    const input = document.createElement('input');
    input.setAttribute('value',this.currentVariant.id);
    const alreadyExists = document.querySelector(`#productStand${this.cid}`);
    if(alreadyExists){
     alreadyExists.remove();
    }
    input.setAttribute('id',`productStand${this.cid}`);
    input.setAttribute('type','hidden');
    form.append(input);
    
   

    this.addstand = true;
 
   
  }

  toggleStand(event, target){
    if (this.addstand == false){
      target.setAttribute('aria-selected', true);
      this.addstand = true;
    } else {
      target.setAttribute('aria-selected', false);
      if(target.parentElement.querySelector('.twoSetControl--RaisedOptionWrapper[aria-selected="true"]')){
        target.parentElement.querySelector('.twoSetControl--RaisedOptionWrapper[aria-selected="true"]').setAttribute('aria-selected','false');
      }
     
  
      this.addstand = false;
    }

    let price = 0;
    const elementSelected = document.querySelector('.twoSetControl--Option[aria-selected="true"]');
      if (elementSelected){
         price = parseInt(elementSelected.dataset.price);
      }
  
      const floatingPrice = document.querySelector('.floatingPrices .changePrice');
     
  
      const allUpsell = document.querySelectorAll('.twoSetControl--RaisedTitle[aria-selected="true"]');
  
      allUpsell.forEach((item) => {
        price += parseInt(item.dataset.price);
      })
  
      if (floatingPrice){
        floatingPrice.innerHTML = Shopify.formatMoney(price, window.theme.moneyFormat);
      }
  }

  toggleOptions(event, target){
    const allToggles = this.element.querySelectorAll('.twoSetControl--Option');
    allToggles.forEach((item) => {
      item.setAttribute('aria-selected', 'false');
    });
    let price = parseInt(target.dataset.price);
    const compareAtPriceRaw = target.dataset.compare;
    const floatingPrice = document.querySelector('.floatingPrices .changePrice');
   
    const allUpsell = document.querySelectorAll('.twoSetControl--RaisedTitle[aria-selected="true"]');

    allUpsell.forEach((item) => {
      price += parseInt(item.dataset.price);
    })

    const hasVariantSelectsComplete = !!document.querySelector('variant-selectscomplete');

    // If the two-complete-set variant controller is NOT present, update all price
    // displays directly from the selected set card (plus any active upsell).
    if (!hasVariantSelectsComplete) {
      const compareAtPrice = compareAtPriceRaw ? parseInt(compareAtPriceRaw) : null;

      let quantity = 1;
      const quantityInput = document.querySelector('input.QuantitySelector__ProductQuantity');
      if (quantityInput) {
        const parsedQty = parseInt(quantityInput.value, 10);
        if (!isNaN(parsedQty) && parsedQty > 0) {
          quantity = parsedQty;
        }
      }

      const formattedPrice = Shopify.formatMoney(price * quantity, window.theme.moneyFormat);
      const formattedCompareAt = compareAtPrice != null
        ? Shopify.formatMoney(compareAtPrice * quantity, window.theme.moneyFormat)
        : null;

      const priceDivs = Array.from(document.querySelectorAll('.changePrice'));
      const compareDivs = Array.from(document.querySelectorAll('.changePriceCompare'));

      priceDivs.forEach((priceDiv) => {
        priceDiv.setAttribute('data-price', price);
        priceDiv.innerHTML = formattedPrice;
      });

      compareDivs.forEach((compareDiv) => {
        if (formattedCompareAt) {
          compareDiv.innerHTML = formattedCompareAt;
          compareDiv.style.removeProperty('display');
        } else {
          compareDiv.style.display = 'none';
        }
      });

      if (floatingPrice){
        floatingPrice.innerHTML = formattedPrice;
      }

      // Update floating "Save" text (if present) to reflect the new discount percentage
      const saveDiv = document.querySelector('.floatingSave');
      if (saveDiv) {
        if (compareAtPrice != null && compareAtPrice > price) {
          saveDiv.style.display = '';
          const percentage = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
          const text = saveDiv.innerText;
          const modifiedString = text.replace(/\d+%?/, percentage + '%');
          saveDiv.innerText = modifiedString;
        } else {
          saveDiv.style.display = 'none';
        }
      }
    }

    target.setAttribute('aria-selected', 'true');
    const toggleId = target.dataset.id;
    const allOptions = document.querySelectorAll('.twoControls-SecondOptions');
    if (toggleId == 'first'){
      allOptions.forEach((item) => {
        item.setAttribute('aria-hidden','true');
      });
      const allInputs = document.querySelectorAll('#completeSet [data-cid="_2"]');
      allInputs.forEach((item) =>{
        item.remove();
      });
    } else {
      this.element.dispatchEvent(
        new CustomEvent("second:selected", {
          bubbles: true
        })
      );
  
      allOptions.forEach((item) => {
        item.setAttribute('aria-hidden','false');
      });
    }
    this.element.dispatchEvent(
      new CustomEvent("variant:price:changed", {
        bubbles: true
       
      })
    );
    // Re-evaluate ATC sold-out state when switching between 1x / 2x set
    document.body.dispatchEvent(new CustomEvent('complete-set:variant-changed'));
  }
  
}
customElements.define("twoset-controller", twoSets);


class VariantSelectsComplete extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.colorName = this.element.querySelector('.VariantSelect--VariantColorName');

    this.getVariantData();

    this.removeNonexistentVariants();
    this.bindEvents();
  }

  bindEvents(){
    this.delegateBody.on("quantity:changed", this.onVariantChange.bind(this));
    this.delegateBody.on("second:selected", this.secondUpdate.bind(this));
    this.delegateBody.on("variant:price:changed", this.updatePrice.bind(this));
    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });

    if (this.colorName) {
      this.delegateBody.on('mouseover', '.SelectBox--ColorWrapper', this.handleMouseOverColor.bind(this));
      this.delegateBody.on('mouseout', '.SelectBox--ColorWrapper', this.handleColorMouseOut.bind(this));
    }

    this.delegateBody.on('click', '[data-action="color-variant-click"]', this.handleColorVariantClick.bind(this));

    this.delegateElement.on("keydown", onEnter((event) =>{
      event.target.previousElementSibling.click();
    }))
  }

  handleColorVariantClick() {
    const target = event.target.closest('[data-action="color-variant-click"]');
    const wrapper = target.closest(".SelectBox--ColorWrapper");
    const targetsInput = target.querySelector("input");
    const button = document.querySelector(".floatingATC");
    const formInput = document.querySelector("#completeSet input");

    if (!button) return;

    if (targetsInput.disabled) {
      button.setAttribute("data-action", "");
      button.classList.add("klaviyo-bis-trigger");

      if (wrapper.querySelector("input:checked")) wrapper.querySelector("input:checked").checked = false;
      targetsInput.checked = true;

      targetsInput.dispatchEvent(
        new CustomEvent("change", {
          bubbles: true,
        })
      );

      const content = document.querySelector("#floatingATC--oos")?.innerHTML;
      if (content) {
        button.innerHTML = content;
      }
    } else {
      button.setAttribute("data-action", "complete-set");
      button.classList.remove("klaviyo-bis-trigger");
      const content = document.querySelector("#floatingATC--is")?.innerHTML;
      if (content) {
        button.innerHTML = content;
      }
    }
  }

  updatePrice() {  
    const secondOption = document.querySelector('.twoSetControl--Option[aria-selected="true"][data-id="second"]');
    const variantJson = JSON.parse(this.element.querySelector("#Product--VariantData").textContent);

    if (secondOption) {
      /* array of all variant combinations */ 


      /* finds all of the selected inputs for first product and saves its value */ 
      const firstOptions = Array.from(this.element.querySelectorAll(".twoControls-FirstOptions"));

      const firstValues = firstOptions?.map(item => item.querySelector("input:checked")?.value);

      /* finds all of the selected inputs for second product and saves its value */ 
      const secondOptions = Array.from(this.element.querySelectorAll(".twoControls-SecondOptions"));
      const secondValues = secondOptions?.map(item => item.querySelector("input:checked")?.value);

      /* checks if any of the variant combinations matches with the selected inputs */
      const matchingVariant1 = variantJson.filter(item => firstValues.every(word => item.title.includes(word)));
      /* checks if any of the variant combinations matches with the selected inputs */
      const matchingVariant2 = variantJson.filter(item => secondValues.every(word => item.title.includes(word)));
      if (!matchingVariant1[0] || !matchingVariant2[0]) return;
      let price = matchingVariant1[0].price + matchingVariant2[0].price;
      const discount = document.querySelector('twoset-controller').dataset.discount;
     
      price = price - parseInt(discount);

      let quantity = 1;
      const quantityInput = this.element.querySelector("input.QuantitySelector__ProductQuantity");
      if (quantityInput) {
        quantity = quantityInput.value;
      }
      let formatedPrice = Shopify.formatMoney(
        price * quantity,
        window.theme.moneyFormat
      );
      const compareAtPrice = matchingVariant1[0].compare_at_price + matchingVariant2[0].compare_at_price;
      const formatedPriceCompare = Shopify.formatMoney(
        compareAtPrice * quantity,
        window.theme.moneyFormat
      );

      console.log(formatedPrice, formatedPriceCompare);

      const priceDivs = Array.from(document.querySelectorAll(".changePrice"));
      const priceDivsCompare = Array.from(document.querySelectorAll(".changePriceCompare"));
      const priceDivs2 = Array.from(document.querySelectorAll(".changePrice_2"));
      const priceDivsCompare2 = Array.from(document.querySelectorAll(".changePriceCompare_2"));

      const saveDiv = document.querySelector('.floatingSave');
      if (saveDiv){
        const text = saveDiv.innerText;
        const difference = compareAtPrice - price;
        const formatedDifference = Shopify.formatMoney(
          difference,
          window.theme.moneyFormat
        );
        const percentage = Math.round((difference / compareAtPrice) * 100);
        const modifiedString = text.replace(/\d+%?/, percentage + '%');
        if (document.querySelector('.savePoint_2')) {
          document.querySelector('.savePoint_2').innerText = formatedDifference;
        }
        saveDiv.innerText = modifiedString;
      }
      
      priceDivs.forEach(priceDiv => {


        priceDiv.setAttribute("data-price", price);
        priceDiv.innerText = formatedPrice;

    })
      
    priceDivsCompare.forEach(priceDiv => {

          priceDiv.innerText = formatedPriceCompare;
 
      })

      priceDivs2.forEach(priceDiv => {


        priceDiv.setAttribute("data-price", price);
        priceDiv.innerText = formatedPrice;

    })
      
    priceDivsCompare2.forEach(priceDiv => {

          priceDiv.innerText = formatedPriceCompare;
 
      })



    } else {

      const firstOptions = Array.from(this.element.querySelectorAll(".twoControls-FirstOptions"));

      const firstValues = firstOptions?.map(item => item.querySelector("input:checked")?.value);
    
      const matchingVariant1 = variantJson.filter(item => firstValues.every(word => item.title.includes(word)));
      if (!matchingVariant1[0]) return;
      let price =  matchingVariant1[0].price;
      const compareAtPrice = matchingVariant1[0].compare_at_price;
      const priceDivs = Array.from(document.querySelectorAll(".changePrice"));
      const priceDivsCompare = Array.from(document.querySelectorAll(".changePriceCompare"));
      const priceDivs2 = Array.from(document.querySelectorAll(".changePrice_1"));
      const priceDivsCompare2 = Array.from(document.querySelectorAll(".changePriceCompare_1"));
    
      if (!price) {
        return;
      }

      let quantity = 1;
      const quantityInput = this.element.querySelector("input.QuantitySelector__ProductQuantity");
      if (quantityInput) {
        quantity = quantityInput.value;
      }
  
      const formatedPrice = Shopify.formatMoney(
        price * quantity,
        window.theme.moneyFormat
      );
      const formatedPriceCompare = Shopify.formatMoney(
        compareAtPrice * quantity,
        window.theme.moneyFormat
      );

      priceDivs.forEach(priceDiv => {


        priceDiv.setAttribute("data-price", price);
        priceDiv.innerText = formatedPrice;

    })

    const saveDiv = document.querySelector('.floatingSave');
    if (saveDiv){
      const text = saveDiv.innerText;
      const difference = compareAtPrice - price;
      const formatedDifference = Shopify.formatMoney(
        difference,
        window.theme.moneyFormat
      );
      const percentage = Math.round((difference / compareAtPrice) * 100);
      const modifiedString = text.replace(/\d+%?/, percentage + '%');
      document.querySelector('.savePoint_1').innerText = formatedDifference;
      saveDiv.innerText = modifiedString;
    }
      
    priceDivsCompare.forEach(priceDiv => {

          priceDiv.innerText = formatedPriceCompare;
 
      })

      priceDivs2.forEach(priceDiv => {


        priceDiv.setAttribute("data-price", price);
        priceDiv.innerText = formatedPrice;

    })
      
    priceDivsCompare2.forEach(priceDiv => {

          priceDiv.innerText = formatedPriceCompare;
 
      })


    }
  }

  handleMouseOverColor() {
    const input = event.target.closest('.Selectbox')?.querySelector('.inputSelectboxCheckbox');
   
    if (input) {
      let cid = input?.dataset.cid;
      this.colorName = this.element.querySelector('[data-label_cid="' + cid + '"]');
      this.oldColorName = this.colorName.innerText;
      this.colorName.innerText = input.value;
    }
  }

  handleColorMouseOut() {
    if (this.oldColorName) {
      this.colorName.innerText = this.oldColorName;
    }
  }

  updateVariantStatuses(cid) {
    let inputWrappers = [...this.querySelectorAll('.VariantSelect_2')];

    if(!cid || cid == "_1"){
      cid = "_1";
       inputWrappers = [...this.querySelectorAll('.VariantSelect_1')];
    }

    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(`input[data-cid="${cid}"]:checked`).value === variant.option1);


    inputWrappers.forEach((option, index) => {
      
      if (index === 0) return;

      const optionInputs = [...option.querySelectorAll(`input[data-cid="${cid}"]`)];

      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;

      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {

    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.removeAttribute('disabled');
      } else {
        input.setAttribute('disabled','true');
      }
    });
  }

  secondUpdate(){
    const cid = "_2"
    this.updateOptions(cid);
    this.updateMasterId();
    this.updateVariantInput();
 
    this.updateAddToCart(cid);
   this.updateVariantStatuses(cid);
  }

  onVariantChange(event, target) {
    const cid = event.target.dataset.cid;
    this.updatePrice();
    this.updateOptions(cid);
    this.updateMasterId();
    this.updatePickupAvailability();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateAddToCart(cid);
    this.updateVariantStatuses(cid);

    if (event.target.matches('.inputSelectboxCheckbox--Color')) {
      this.oldColorName = event.target.value;
    } else if (event.target.matches('[data-option="Size"]')) {
      this.removeNonexistentVariants();
    }
  }

  updateOptions(cid) {
    this.options = Array.from(
      this.querySelectorAll(`select[data-cid="${cid}"], input[data-cid="${cid}"]:checked`),
      (select) => select.value
    );
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;


    if (!this.currentVariant.featured_media) return;
    const newMedia = this.currentVariant.featured_media.id;

    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    if(this.currentVariant){
      const productForms = document.querySelectorAll(
        `#product-form-${this.productID}, #product-form-installment`
      );
  
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    if(this.currentVariant){
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".floatingPrices";
        const id_2 =".ProductInfo--Prices.headerPrices";
        const html = new DOMParser().parseFromString(responseText, "text/html");
      
        const destination = document.querySelector(id);
        const destination_2 = document.querySelector(id_2);
        
        const source = html.querySelector(id);
        const source_2 = html.querySelector(id_2);

      
        
        /* const newPrices = document.querySelector('.floatingPrices').innerHTML = source.innerHTML; */
        
      });
    }
  }

  updateAddToCart(cid){
    if(this.currentVariant){


   const form = document.querySelector('#completeSet');

   const input = document.createElement('input');
   input.setAttribute('value',this.currentVariant.id);
   const alreadyExists = document.querySelector(`#product${this.productID}${cid}`);
   if(alreadyExists){
    alreadyExists.remove();
   }
   input.setAttribute('data-cid',cid)
   input.setAttribute('id',`product${this.productID}${cid}`);
   input.setAttribute('type','hidden');
   form.append(input);
  }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  // some variant combinations should not be shown 
  // example. if large red exists and medium red does not, when user selects medium it will still show red color swatch
  removeNonexistentVariants() {
    const sizeVariant = this.element.querySelector('input[data-option="Size"]:checked');
    const colorsContainer = this.element.querySelector(".SelectBox--ColorWrapper");

    if (sizeVariant && colorsContainer) {
      const colorInputs = Array.from(colorsContainer.querySelectorAll("input"));

      // keeps only variants with checked size variant (if medium is checked, filters out large variants)
      const filteredVariants = this.variantData.filter(item => item.options.includes(sizeVariant.value));
      
      const filterInputs = colorInputs.filter(colorInput => {
        const some = filteredVariants.some( variant => {
          // console.log(variant.options, colorInput.value, variant.options.includes(colorInput.value));
          return variant.options.includes(colorInput.value)
        })

        if (some) {
          return colorInput;
        }
      });

      colorInputs.forEach( input => {
        if (filterInputs.includes(input)) {
          input.parentElement.style.display = "block"
        } else {
          input.parentElement.style.display = "none"
        }
      })
    }
  }
}
customElements.define("variant-selectscomplete", VariantSelectsComplete);

class Search extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.result = this.element.querySelectorAll(".Search--Result");

    this.openProductBtn = this.element.querySelector('#productBtn');
    this.openArticleBtn = this.element.querySelector('#articleBtn');
    this.showProducts();
    this.bindEvents();

    /* get number of products & articles */
    var productNumber = this.element.querySelectorAll(".cardWrapper").length;
    var itemNumber = this.element.querySelector('.itemNumber');
    itemNumber.innerHTML = productNumber;

    var articleNumber = this.element.querySelectorAll(".article-wrapper").length;
    var itemNumber_2 = this.element.querySelector('.itemNumber_2');
    itemNumber_2.innerHTML = articleNumber;
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="toggle-products"]', this.showProducts.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-articles"]', this.showArticles.bind(this));
  }

  showProducts() {
    this.getProducts = this.element.querySelectorAll(".cardWrapper");
    this.hideArticles = this.element.querySelectorAll(".article-wrapper");

    this.hideArticles.forEach(function (article) {
      article.classList.add('hidden')
    })
    this.getProducts.forEach(function (product){
      product.classList.remove('hidden')
    })
    this.openProductBtn.classList.add('active');
    this.openArticleBtn.classList.remove('active');

  }

  showArticles() {
    this.getArticles = this.element.querySelectorAll(".article-wrapper");
    this.hideProducts = this.element.querySelectorAll(".cardWrapper");

    this.hideProducts.forEach(function (product) {
      product.classList.add('hidden')
    })
    this.getArticles.forEach(function (article){
      article.classList.remove('hidden')
    })
    this.openProductBtn.classList.remove('active');
    this.openArticleBtn.classList.add('active');
  }
}
customElements.define("search-component", Search);


class AnnBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.breakpoint = new Responsive().getCurrentBreakpoint();

    if (this.breakpoint == "phone" || this.breakpoint == "pocket"){
      new RevolutionSwiper(this.element.querySelector('.swiper'));
    }

  }


}
customElements.define("announcement-bar", AnnBar);



class UpsellPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.bindEvents();
  }
  
  bindEvents(){
    this.delegateElement.on('click', '[data-action="choose-stand"]', this.toggleStandOption.bind(this));
    this.delegateElement.on('click', '[data-action="add-to-checkout"]', this.addToCheckout.bind(this));
    this.delegateBody.on('click', '.closeUpsell[data-action="close-modal"]',(event)=>{
      event.stopImmediatePropagation();
      this.closeModal();
    })
  }

  closeModal(){
    document.querySelector('.pageOverlayCart').click();
  }

  addToCheckout(){
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;

    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = this.element.querySelector('#upsellProduct');
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        addToCartButton.removeAttribute("disabled");
        window.location.href ='/checkout';
      } else {
        response.json().then(function (content) {

        });
      }
    });
  }

  toggleStandOption(event, target){
    const otherItem = this.element.querySelector('[aria-selected="true"]');
    if(otherItem){
      otherItem.setAttribute('aria-selected','false');
    }

    this.element.querySelector('.addToCheckout').removeAttribute('disabled');
    target.setAttribute('aria-selected', 'true');
    const id = target.getAttribute('data-value');
    const form = this.element.querySelector('#upsellInput');
    form.value = id;
  }


}
customElements.define("upsell-popup", UpsellPopup);

class PaginableElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.paginationFunction();

  }
  
  paginationFunction(){
    const cardsPerPage = 12; // Number of cards to show per page 
    const dataContainer = document.getElementById('data-container'); 
    const pagination = document.getElementById('pagination'); 
    const prevButton = document.getElementById('prev'); 
    const nextButton = document.getElementById('next'); 
    const pageNumbers = document.getElementById('page-numbers'); 
    const pageLinks = document.querySelectorAll('.page-link'); 
      
    const cards =  
        Array.from(dataContainer.getElementsByClassName('card')); 
      
    // Calculate the total number of pages 
    const totalPages = Math.ceil(cards.length / cardsPerPage); 
    let currentPage = 1; 
      
    // Function to display cards for a specific page 
    function displayPage(page) { 
        const startIndex = (page - 1) * cardsPerPage; 
        const endIndex = startIndex + cardsPerPage; 
        cards.forEach((card, index) => { 
            if (index >= startIndex && index < endIndex) { 
                card.style.display = 'flex'; 
            } else { 
                card.style.display = 'none'; 
            } 
        }); 
    } 
      
    // Function to update pagination buttons and page numbers 
    function updatePagination() { 
        pageNumbers.textContent =  
            `Page ${currentPage} of ${totalPages}`; 
        prevButton.disabled = currentPage === 1; 
        nextButton.disabled = currentPage === totalPages; 
        pageLinks.forEach((link) => { 
            const page = parseInt(link.getAttribute('data-page')); 
            link.classList.toggle('active', page === currentPage); 
        }); 
        if(currentPage == totalPages){
          nextButton.style.opacity = '0.2';
          nextButton.style.pointerEvents = 'none';
        } else {
          nextButton.style.opacity = '1';
          nextButton.style.pointerEvents = 'all';
        }
        if(currentPage == 1){
          prevButton.style.opacity = '0.2';
          prevButton.style.pointerEvents = 'none';
        } else{
          prevButton.style.opacity = '1';
          prevButton.style.pointerEvents = 'all';
        }
    } 
      
    // Event listener for "Previous" button 
    prevButton?.addEventListener('click', () => { 
        if (currentPage > 1) { 
            currentPage--; 
            displayPage(currentPage); 
            updatePagination(); 
        } 
    }); 
      
    // Event listener for "Next" button 
    nextButton?.addEventListener('click', () => { 
        if (currentPage < totalPages) { 
            currentPage++; 
            displayPage(currentPage); 
            updatePagination(); 
        } 
    }); 
      
    // Event listener for page number buttons 
    pageLinks.forEach((link) => { 
        link.addEventListener('click', (e) => { 
            e.preventDefault(); 
            const page = parseInt(link.getAttribute('data-page')); 
            if (page !== currentPage) { 
                currentPage = page; 
                displayPage(currentPage); 
                updatePagination(); 
            } 
        }); 
    }); 
      
    // Initial page load 
    displayPage(currentPage); 
    //updatePagination();
  }


}
customElements.define("paginable-element", PaginableElement);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const observer = new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '-100px 0px 200px 0px'});
    observer.observe(this.element);
  }

  async handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    try {
        const response = await fetch(this.dataset.url);
        const text = await response.text();
  
        const html = document.createElement('div');
        html.innerHTML = text;
  
        const recommendations = html.querySelector('product-recommendations');
  
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
  
          new RevolutionSwiper(this.querySelector('.swiper'));
  
          if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
            new RevolutionAnimation(this);
          }
        }
    } catch (e) {
        console.error(e);
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class SizeGuide extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.swiperInstance = null;
    this.swiperElement = null;
    this.delegateElement = new Delegate(this);
  }

  connectedCallback() {
    const drawerEl = this.querySelector('#size-guide');
    if (drawerEl) new Drawer(drawerEl);

    const swiperEl = this.querySelector('.size-guide__swiper');
    if (!swiperEl) return;

    this.swiperInstance = new RevolutionSwiper(swiperEl);
    this.swiperElement = swiperEl.swiper;

    this.bindEvents();

    this.renderTemplateFromSlide(this.swiperElement.slides[this.swiperElement.activeIndex]);
  }

  disconnectedCallback() {
    this.delegateElement.destroy();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '.swiper-slide',
      this.handleSlideClick.bind(this)
    );

    this.delegateElement.on(
      "keydown",
      '.swiper-slide',
      onEnter((event) => {
        this.handleSlideKeyPress(event);
      })
    );
  }

  handleSlideClick(event, target) {
    const swiper = this.swiperElement;

     if (!swiper.allowClick) {
    return;
  }

  // Make sure we're working with the actual slide element
  const clickedSlide = swiper.clickedSlide;

  if (!clickedSlide) return;

  const clickedIndex = swiper.slides.indexOf(clickedSlide);

  if (clickedIndex !== -1) {
    swiper.slideTo(clickedIndex, 300);
    this.setActiveSlide(clickedIndex);
    this.renderTemplateFromSlide(clickedSlide);
  }


}

  handleSlideKeyPress(event) {
    const swiper = this.swiperElement;
    const pressedSlide = event.target.closest('.swiper-slide');

    if (!pressedSlide) return;

    const pressedIndex = swiper.slides.indexOf(pressedSlide);

    if (pressedIndex !== -1) {
      swiper.slideTo(pressedIndex, 300);
      this.setActiveSlide(pressedIndex);
      this.renderTemplateFromSlide(pressedSlide, pressedSlide);
    }
  }

  // Set the active class on the clicked slide and remove it from others
  setActiveSlide(clickedIndex) {
    const allSlides = this.swiperElement.slides;

    // Remove the 'swiper-slide-active' class from all slides
    allSlides.forEach(slide => {
      slide.classList.remove('swiper-slide-active');
    });

    // Add the 'swiper-slide-active' class to the clicked slide
    const clickedSlide = allSlides[clickedIndex];
    if (clickedSlide) {
      clickedSlide.classList.add('swiper-slide-active');
    }
  }

  renderTemplateFromSlide(slideEl, elementToFocus = null) {
    const tabContent = this.querySelector('.size-guide__tab-content');
    if (!tabContent || !slideEl) return;

    let nextEl = slideEl.nextElementSibling;
    while (nextEl && nextEl.tagName !== 'TEMPLATE') {
      nextEl = nextEl.nextElementSibling;
    }

    if (nextEl && nextEl.tagName === 'TEMPLATE') {
      tabContent.classList.remove('active');

      setTimeout(() => {
        const content = nextEl.content.cloneNode(true);
        tabContent.innerHTML = '';
        tabContent.appendChild(content);

        tabContent.classList.add('active');

        // Update focus trap to include new dynamically added elements
        const drawerEl = this.querySelector('#size-guide');
        if (drawerEl && drawerEl.getAttribute('aria-expanded') === 'true') {
          // If we have an element to focus (from keyboard navigation), focus it
          // Otherwise let trapFocus handle the default behavior
          if (elementToFocus) {
            trapFocus(drawerEl, elementToFocus);
            // Manually refocus the element since trapFocus might focus something else
            setTimeout(() => {
              if (elementToFocus && typeof elementToFocus.focus === 'function') {
                elementToFocus.focus();
              }
            }, 50);
          } else {
            trapFocus(drawerEl);
          }
        }
      }, 300);
    }
  }
}

customElements.define('size-guide', SizeGuide);

function onEnter(callback){
  return function(event){
    if(event.key === 'Enter' || event.keyCode === 13) {
      callback(event);
   }
 }
}

function onEscape(callback) {
  return function(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      callback(event);
    }
  }
}

class ProductVariants extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.element.__instance = this;
    this.delegate = new Delegate(this.element);
    this.variantSet = this.element.dataset.variantSet || 'first';
    this.variantData = this.getVariantData();
    this.variant = JSON.parse(this.element.dataset.selectedVariant);

    // Show all options (remove server-side aria-hidden). We'll selectively hide only color swatches
    // that don't exist for the current selection graph.
    this.element.querySelectorAll('input[data-action="select-variant"]').forEach(input => {
      input.setAttribute('aria-hidden', 'false');
      const inputId = input.getAttribute('id');
      const label = inputId ? this.element.querySelector(`label[for="${CSS.escape(inputId)}"]`) : null;
      if (label) label.style.removeProperty('display');
    });

    // Sticky/floating ATC fallback (no twoset-controller on this template).
    // The floating button is rendered as `data-action="complete-set"` in the markup, but without the
    // `twoset-controller` element there is no handler attached for that action. In that case, clicking
    // the floating ATC should submit the main product form so our async add-to-cart flow runs.
    if (!document.querySelector('twoset-controller') && !window.theme?.__floatingAtcFallbackBound) {
      window.theme = window.theme || {};
      window.theme.__floatingAtcFallbackBound = true;
      document.addEventListener('click', (event) => {
        const btn = event.target.closest?.('.floatingATC');
        if (!btn) return;
        if (document.querySelector('twoset-controller')) return;

        event.preventDefault();
        event.stopPropagation();

        const productFormEl = document.querySelector('product-form');
        const form =
          productFormEl?.querySelector('form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add"]');
        if (!form) return;

        if (typeof form.requestSubmit === 'function') {
          const submitter =
            form.querySelector('button[type="submit"], input[type="submit"]') || undefined;
          form.requestSubmit(submitter);
        } else {
          // Older browsers: click a submit button (will be intercepted by our async submit handler)
          const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
          if (submitBtn) submitBtn.click();
          else form.submit();
        }
      }, { capture: true });
    }

    this.updateAtc();
    this.updateOptionStates();
    this.bindEvents();

    // Ensure the color label is visible even without hover
    this.resetColorVariantName();
  }

  disconnectedCallback() {
    this.delegate.destroy();
  }

  getVariantData() {
    const dataScript = this.element.querySelector('[data-variant-data]');
    if (!dataScript) return [];
    try {
      return JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error('Error parsing variant data:', e);
      return [];
    }
  }

  bindEvents() {
    this.delegate.on('change', 'input', this.handleVariantSelected.bind(this));

    // Listen for when 2x set is selected to initialize the second variant input
    if (this.variantSet === 'second') {
      document.body.addEventListener('second:selected', () => {
        this.updateAtc();
      });
    }
    // When second set variant changes, first set component should refresh ATC button state
    if (this.variantSet === 'first') {
      document.body.addEventListener('complete-set:variant-changed', () => {
        this.updateAtcButtonState();
      });
    }

    this.delegate.on("click",'.main-product__variant-option-label--color_swatch', this.handleColorVariantNameChange.bind(this));

    this.delegate.on(
      "mouseover",
      '.main-product__variant-option-label--color_swatch',
      this.handleColorVariantNameChange.bind(this)
    );

    this.delegate.on(
      "mouseout",
      '.main-product__variant-option-label--color_swatch',
      this.resetColorVariantName.bind(this)
    );

  }

  handleColorVariantNameChange(event) {
    // If hovering input directly
    let input = event.target.closest(
      'input[data-action="select-variant"]'
    );

    // If hovering label or swatch, resolve input via "for"
    if (!input) {
      const label = event.target.closest(
        'label.main-product__variant-option-label'
      );
      if (label && label.htmlFor) {
        input = document.getElementById(label.htmlFor);
      }
    }

    if (!input) return;

    const colorName = input.value;
    const colorLabel = this.element.querySelector(
      ".main-product__variant-option-color_swatch .variant-option__name"
    );
    const colorPrepend = colorLabel?.dataset?.color || '';

    if (colorLabel) {
      colorLabel.textContent = colorPrepend + colorName;
    }
  }

  resetColorVariantName(event) {
    // If we're moving to another color swatch label, don't reset
    const relatedTarget = event?.relatedTarget;
    if (relatedTarget && relatedTarget.closest('.main-product__variant-option-label--color_swatch')) {
      return;
    }

    const colorLabel = this.element.querySelector(
      ".main-product__variant-option-color_swatch .variant-option__name"
    );

    if (!colorLabel) return;

    const colorPrepend = colorLabel?.dataset?.color || '';

    // Find all color swatch labels and check which one's input is checked
    const colorSwatchLabels = this.element.querySelectorAll(
      'label.main-product__variant-option-label--color_swatch'
    );

    for (const label of colorSwatchLabels) {
      if (label.htmlFor) {
        const input = document.getElementById(label.htmlFor);
        if (input && input.checked) {
          colorLabel.textContent = colorPrepend + input.value;
          return;
        }
      }
    }

    // Fallback: if no checked input found, at least keep the prefix visible.
    colorLabel.textContent = colorPrepend;
  }


  handleVariantSelected(event) {
    const target = event.target.closest('[data-action="select-variant"]');
    if (!target) return;

    // Find the matching variant based on selected options
    this.updateCurrentVariant();

    console.log('ProductVariants: Selected options', this.getSelectedOptions());
    console.log('ProductVariants: Found variant', this.variant);

    // Only update URL for the first variant set
    if (this.variantSet === 'first' && this.variant) {
      this.updateUrl();
    }

    this.updateAtc();

    if (this.variantSet === 'first') {
      this.updatePriceDisplay();
    } else if (this.variantSet === 'second') {
      // Trigger the first set's price display update so the combined 2x price recalculates
      const firstSet = document.querySelector('product-variants[data-variant-set="first"]');
      if (firstSet?.__instance) {
        firstSet.__instance.updatePriceDisplay();
      }
    }

    this.updateOptionStates();
  }

  getSelectedOptions() {
    const options = {};
    const selectedInputs = this.element.querySelectorAll('input:checked');
    selectedInputs.forEach(input => {
      const position = input.dataset.optionPosition;
      options['option' + position] = input.value;
    });
    return options;
  }

  updateCurrentVariant() {
    const selectedOptions = this.getSelectedOptions();

    // Find the variant that matches all selected options
    this.variant = this.variantData.find(variant => {
      return Object.keys(selectedOptions).every(key => {
        return variant[key] === selectedOptions[key];
      });
    });
  }

  updateUrl() {
    if (!this.variant) return;
    const url = new URL(window.location);
    url.searchParams.set("variant", this.variant.id);
    history.replaceState({}, "", url);
  }

  getOrCreateCompleteSetForm() {
    let form = document.querySelector('#completeSet');
    if (!form) {
      // Create the completeSet form if it doesn't exist
      form = document.createElement('form');
      form.id = 'completeSet';
      form.style.display = 'none';

      // Add the first product input
      const firstInput = document.createElement('input');
      firstInput.type = 'hidden';
      firstInput.id = 'product-variant-1';
      firstInput.name = 'id';
      form.appendChild(firstInput);

      // Insert form into the twoset-controller or body
      const controller = document.querySelector('twoset-controller');
      if (controller) {
        controller.appendChild(form);
      } else {
        document.body.appendChild(form);
      }
      console.log('Created #completeSet form');
    }
    return form;
  }

  updateAtc() {
    // If the selected options don't map to a real variant, treat as sold out
    if (!this.variant) {
      if (this.variantSet === 'first') {
        this.updateAtcButtonState();
      } else if (this.variantSet === 'second') {
        const completeSetForm = document.querySelector('#completeSet');
        const secondInput = completeSetForm?.querySelector('#product-variant-2');
        if (secondInput) {
          secondInput.value = '';
        }
        // Notify first set instance to recompute sold-out state
        document.body.dispatchEvent(new CustomEvent('complete-set:variant-changed'));
      }
      return;
    }

    // Ensure completeSet form exists
    const completeSetForm = this.getOrCreateCompleteSetForm();

    if (this.variantSet === 'first') {
      // Update the main product form
      const productForm = document.querySelector('[data-type="add-to-cart-form"]');
      if (productForm) {
        const productFormInput = productForm.querySelector('input[name="id"]');
        if (productFormInput) {
          productFormInput.value = this.variant.id;
          console.log('updateAtc first: updated product form input to', this.variant.id);
        }
      }

      // Update completeSet form first input
      let completeSetInput = completeSetForm.querySelector('#product-variant-1') || completeSetForm.querySelector('input[name="id"]');
      if (completeSetInput) {
        completeSetInput.value = this.variant.id;
        console.log('updateAtc first: updated completeSet input to', this.variant.id);
      }

      // Sync sold-out state and content for main ATC and floating ATC on variant change
      this.updateAtcButtonState();
    } else if (this.variantSet === 'second') {
      // Only update second input if 2x set is selected
      const secondSetSelected = document.querySelector('.twoSetControl--Option[aria-selected="true"][data-id="second"]');
      console.log('updateAtc second: 2x set selected?', !!secondSetSelected);
      if (!secondSetSelected) return;

      // Update or create the second product input
      let secondInput = completeSetForm.querySelector('#product-variant-2');
      console.log('updateAtc second: existing input?', !!secondInput);
      if (!secondInput) {
        secondInput = document.createElement('input');
        secondInput.type = 'hidden';
        secondInput.id = 'product-variant-2';
        secondInput.name = 'id';
        secondInput.dataset.cid = '_2';
        completeSetForm.appendChild(secondInput);
        console.log('updateAtc second: created new input');
      }
      secondInput.value = this.variant.id;
      console.log('updateAtc second: set value to', this.variant.id);
      document.body.dispatchEvent(new CustomEvent('complete-set:variant-changed'));
    }
  }

  updateAtcButtonState() {
    if (this.variantSet !== 'first') return;
    const productForm = document.querySelector('[data-type="add-to-cart-form"]');
    const mainButton = productForm?.querySelector('.ProductPage--ATC');
    const floatingButton = document.querySelector('.floatingATC');
    let available = this.variant ? this.variant.available : false;
    // If second set is selected, require both variants to be available for ATC
    const secondSetSelected = document.querySelector('.twoSetControl--Option[aria-selected="true"][data-id="second"]');
    if (secondSetSelected) {
      const completeSetForm = document.querySelector('#completeSet');
      const secondInput = completeSetForm?.querySelector('#product-variant-2');
      const secondId = secondInput?.value;
      if (secondId && this.variantData?.length) {
        const secondVariant = this.variantData.find((v) => String(v.id) === String(secondId));
        available = available && (secondVariant ? secondVariant.available : false);
      } else {
        // 2x is selected but second set has no valid variant selected
        available = false;
      }
    }
    const soldOutClass = 'ProductCard--Sold__Out';
    const bisClass = 'klaviyo-bis-trigger';

    if (mainButton) {
      const span = mainButton.querySelector('.SelfAlign');
      if (available) {
        mainButton.classList.remove(soldOutClass, bisClass);
        mainButton.setAttribute('data-action', 'complete-set');
        mainButton.style.removeProperty('display');
        console.log('updateAtcButtonState first: main button displayed');
        const isTemplate = document.querySelector('#mainATC--is');
        if (span && isTemplate) {
          span.innerHTML = isTemplate.innerHTML;
          const oneSet = span.querySelector('.product-atc__one-set');
          const twoSet = span.querySelector('.product-atc__two-set');
          if (oneSet && window.theme?.moneyFormat) {
            oneSet.textContent = Shopify.formatMoney(this.variant.price, window.theme.moneyFormat);
          }
          if (twoSet && window.theme?.moneyFormat) {
            const discount = parseInt(document.querySelector('twoset-controller')?.dataset?.discount || '0', 10);
            let secondPrice = this.variant.price;
            const secondVariantEl = document.querySelector('product-variants[data-variant-set="second"]');
            if (secondVariantEl?.__instance?.variant) {
              secondPrice = secondVariantEl.__instance.variant.price;
            }
            twoSet.textContent = Shopify.formatMoney(this.variant.price + secondPrice - discount, window.theme.moneyFormat);
          }
        }
      } else {
        mainButton.classList.add(soldOutClass, bisClass);
        mainButton.removeAttribute('data-action');
        const oosTemplate = document.querySelector('#mainATC--oos');
        if (span && oosTemplate) {
          span.innerHTML = oosTemplate.innerHTML;
        }
      }
    }

    if (floatingButton) {
      if (available) {
        floatingButton.classList.remove(bisClass);
        floatingButton.setAttribute('data-action', 'complete-set');
        floatingButton.style.removeProperty('display');
        const isContent = document.querySelector('#floatingATC--is')?.innerHTML;
        if (isContent) floatingButton.innerHTML = isContent;
      } else {
        floatingButton.classList.add(bisClass);
        floatingButton.removeAttribute('data-action');
        const oosContent = document.querySelector('#floatingATC--oos')?.innerHTML;
        if (oosContent) floatingButton.innerHTML = oosContent;
      }
    }
  }

  updatePriceDisplay() {
    if (!this.variant) return;

    const selectedSet = document.querySelector('.twoSetControl--Option[aria-selected="true"]');
    const isSecondSet = selectedSet && selectedSet.dataset.id === 'second';
    const discount = parseInt(document.querySelector('twoset-controller')?.dataset?.discount || '0', 10);

    const variantPrice = this.variant.price;
    const variantCompare = this.variant.compare_at_price;

    // Recalculate the data-price / data-compare on the two-set toggle cards so
    // that future set-switches use the current variant's price.
    const firstCard = document.querySelector('.twoSetControl--Option[data-id="first"][data-action="toggle-options"]');
    const secondCard = document.querySelector('.twoSetControl--Option[data-id="second"][data-action="toggle-options"]');
    if (firstCard) {
      firstCard.dataset.price = String(variantPrice);
      firstCard.dataset.compare = String(variantCompare || '');
    }
    // Resolve the second set's variant prices (falls back to first variant if unavailable)
    const secondVariantEl = document.querySelector('product-variants[data-variant-set="second"]');
    let secondPrice = variantPrice;
    let secondCompare = variantCompare;
    if (secondVariantEl?.__instance?.variant) {
      secondPrice = secondVariantEl.__instance.variant.price;
      secondCompare = secondVariantEl.__instance.variant.compare_at_price;
    }

    if (secondCard) {
      const twoPrice = variantPrice + secondPrice - discount;
      secondCard.dataset.price = String(twoPrice);
      secondCard.dataset.compare = String((variantCompare || 0) + (secondCompare || 0) || '');
    }

    // Determine the display price based on current set selection
    let displayPrice, displayCompare;
    if (isSecondSet) {
      displayPrice = variantPrice + secondPrice - discount;
      displayCompare = (variantCompare || 0) + (secondCompare || 0);
    } else {
      displayPrice = variantPrice;
      displayCompare = variantCompare;
    }

    let quantity = 1;
    const quantityInput = document.querySelector('input.QuantitySelector__ProductQuantity');
    if (quantityInput) {
      const q = parseInt(quantityInput.value, 10);
      if (!isNaN(q) && q > 0) quantity = q;
    }

    const formattedPrice = Shopify.formatMoney(displayPrice * quantity, window.theme.moneyFormat);

    // Update all .changePrice elements (product info + floating buy)
    document.querySelectorAll('.changePrice').forEach(el => {
      el.setAttribute('data-price', displayPrice);
      el.innerHTML = formattedPrice;
    });

    // Update compare-at price elements
    if (displayCompare && displayCompare > displayPrice) {
      const formattedCompare = Shopify.formatMoney(displayCompare * quantity, window.theme.moneyFormat);
      document.querySelectorAll('.changePriceCompare').forEach(el => {
        el.innerHTML = formattedCompare;
        el.style.removeProperty('display');
      });
    } else {
      document.querySelectorAll('.changePriceCompare').forEach(el => {
        el.style.display = 'none';
      });
    }

    // Update the set-card inline prices (changePrice_1 / changePrice_2)
    document.querySelectorAll('.changePrice_1').forEach(el => {
      el.innerHTML = Shopify.formatMoney(variantPrice, window.theme.moneyFormat);
    });
    document.querySelectorAll('.changePriceCompare_1').forEach(el => {
      if (variantCompare && variantCompare > variantPrice) {
        el.innerHTML = Shopify.formatMoney(variantCompare, window.theme.moneyFormat);
        el.style.removeProperty('display');
      } else {
        el.style.display = 'none';
      }
    });
    if (secondCard) {
      const twoPrice = variantPrice + secondPrice - discount;
      const twoPriceCompare = (variantCompare || 0) + (secondCompare || 0);
      document.querySelectorAll('.changePrice_2').forEach(el => {
        el.innerHTML = Shopify.formatMoney(twoPrice, window.theme.moneyFormat);
      });
      document.querySelectorAll('.changePriceCompare_2').forEach(el => {
        if (twoPriceCompare && twoPriceCompare > twoPrice) {
          el.innerHTML = Shopify.formatMoney(twoPriceCompare, window.theme.moneyFormat);
          el.style.removeProperty('display');
        } else {
          el.style.display = 'none';
        }
      });
    }

    // Update .floatingSave
    const saveDiv = document.querySelector('.floatingSave');
    if (saveDiv) {
      if (displayCompare && displayCompare > displayPrice) {
        const diff = displayCompare - displayPrice;
        const formattedDiff = Shopify.formatMoney(diff * quantity, window.theme.moneyFormat);
        const text = saveDiv.innerText;
        const modifiedString = text.replace(/\$.*/, formattedDiff);
        saveDiv.innerText = modifiedString;
        saveDiv.style.removeProperty('display');
      } else {
        saveDiv.style.display = 'none';
      }
    }
  }

  updateOptionStates() {
    const inputs = this.element.querySelectorAll('input[data-action="select-variant"]');
    const selectedOptions = this.getSelectedOptions();

    inputs.forEach(input => {
      const position = input.dataset.optionPosition;
      const value = input.value;

      // Does any variant with this option value exist given the other selected options?
      const variantExists = this.variantData.some(variant => {
        if (variant['option' + position] !== value) return false;
        return Object.keys(selectedOptions).every(key => {
          if (key === 'option' + position) return true;
          return variant[key] === selectedOptions[key];
        });
      });

      // Is at least one of those matching variants in stock?
      const hasAvailableVariant = variantExists && this.variantData.some(variant => {
        if (variant['option' + position] !== value) return false;
        return Object.keys(selectedOptions).every(key => {
          if (key === 'option' + position) return true;
          return variant[key] === selectedOptions[key];
        }) && variant.available;
      });

      input.dataset.variantAvailable = variantExists ? hasAvailableVariant : false;

      // Hide only color swatches that don't exist for the current selection graph.
      const inputId = input.getAttribute('id');
      const label = inputId ? this.element.querySelector(`label[for="${CSS.escape(inputId)}"]`) : null;
      const isColorSwatch =
        !!input.closest('.main-product__variant-option-color_swatch') ||
        !!label?.classList?.contains('main-product__variant-option-label--color_swatch');

      if (isColorSwatch) {
        if (!variantExists) {
          input.setAttribute('aria-hidden', 'true');
          if (label) label.style.display = 'none';
        } else {
          input.setAttribute('aria-hidden', 'false');
          if (label) label.style.removeProperty('display');
        }
      } else {
        // Non-color options should remain visible (and will be styled as unavailable via data-variant-available).
        input.setAttribute('aria-hidden', 'false');
        if (label) label.style.removeProperty('display');
      }
    });
  }

  toggleButtons(enable) {
    const atcButtons = document.querySelectorAll('[data-action="add-to-cart"]');
    atcButtons.forEach((button) => {
      button.disabled = !enable;
    });
  }
}

customElements.define("product-variants", ProductVariants)

class NewProductRecommendations extends HTMLElement{

  constructor() {
    super();
  }

  connectedCallback() {
    this.swiperElement = this.querySelector('.product-recommendations__swiper');
    if (this.swiperElement) {
      this.swiper = new RevolutionSwiper(this.swiperElement);
    }
  }

  disconnectedCallback() {
    if (this.swiper) {
      if (this.swiper.swiperElement) {
        this.swiper.swiperElement.destroy(true, true);
      }
      if (this.swiper.thumbSwiper) {
        this.swiper.thumbSwiper.destroy(true, true);
      }
    }
  }

}
customElements.define("new-product-recommendations", NewProductRecommendations)

class CustomDescription extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.swiperElement = this.querySelector('.custom-description__swiper');
    if (this.swiperElement) {
      this.swiper = new RevolutionSwiper(this.swiperElement);
    }
  }

  disconnectedCallback() {
    if (this.swiper) {
      if (this.swiper.swiperElement) {
        this.swiper.swiperElement.destroy(true, true);
      }
    }
  }
}

customElements.define("custom-description", CustomDescription);